const loading = document.getElementById("loading");
console.log("test glamhive js");
const connectStripe = async () => {
  const stripeConnected = document.getElementById("stripeConnected");
  const connectStripeBtn = document.getElementById("connectStripeBtn");
  connectStripeBtn.onclick = async (e) => {
     e.target.classList.add('spin');
    const bodyData = JSON.stringify({
          returnUrl:
            "https://glamhive.com/pages/stylist-account",
        });
    
      const response = await sendRequest( "stripe/authorize", {
        method: "POST",
        authenticate: true,
        body: bodyData,
      });

    if (response instanceof Error) {
      e.target.classList.remove('spin');
      return;
    }

       window.location.href = response.authorize_url;
    
  };

  const response = await sendRequest( "stripe/details", {
      method: "GET",
      authenticate: true,
  });

  if (response instanceof Error) {
      return;
    }

  if( response.isConnected ) {
    stripeConnected.style.display = 'block';
    connectStripeBtn.style.display = 'none';
  }else{
    stripeConnected.style.display = 'none';
    connectStripeBtn.style.display = 'block';
  }
  
};

const accountFormFields = (firstName, lastName, email, social) => {
  const firstNameEl = document.getElementById("first-name");
  const lastNameEl = document.getElementById("last-name");
  const emailEl = document.getElementById("email");

  document.getElementById("instalink").value = social.instagram || '';
  document.getElementById("fblink").value= social.facebook || '';
  document.getElementById("twitterlink").value= social.twitter || '';
  document.getElementById("linkedinlink").value= social.linkedIn || '';
  document.getElementById("tiktoklink").value= social.tiktok || '';
  document.getElementById("weblink").value= social.website || '';

  firstNameEl.value = firstName;
  lastNameEl.value = lastName;
  emailEl.value = email;
};

//Stylist Logout
const stylistLogout = () => {
  const gmLogout = document.getElementById("gmLogout");
  gmLogout.onclick = async () => {
    const response = await sendRequest("stylist/logout", {
        method: "POST",
        authenticate: true,
      }); 

    if (response instanceof Error) {
      alert(response);
      return;
    }
    localStorage.clear()
    window.location.href = "/account/logout";
    
  }
}

//get stylist profile
const profileData = async (favouriteImages, inspirationImages, introduction, specialities) => {
  const charLimit120 = document.getElementById("charLimit120");
  const charLimit65 = document.getElementById("charLimit65");
  const charLimit400 = document.getElementById("charLimit400");
  const imageContainer = document.getElementById("imageContainer");
  const imageInspirationContainer = document.getElementById("imageInspirationContainer");
  const nodeNamesDiv = document.getElementById("nodeNamesDiv");
  const updateProfile = document.getElementById("update_profile");
  
  charLimit120.value = introduction?.about;
  charLimit65.value = introduction?.quote;
  charLimit400.value = introduction?.philosophy;

// Get All Specialities
      const response = await sendRequest(
        "stylist-specialty/get-all"
      );

     response?.nodes?.forEach((node) => {
       let checked = false;
       specialities.filter( function(s) {
         if( s.specialtyId === node.id){
           return checked=true;
         }
       });
       
      if (node.status === 10){
        nodeNamesDiv.innerHTML = `<div class="profile_about_radio_content"><label>
                        <input type="checkbox" name="option" value="${node.id}" ${checked && 'checked'}><span>${node.name}</span></label></div>
                        ` + nodeNamesDiv.innerHTML;
      }
     });

  // Update Stylist
  updateProfile.onclick = async function(e) {
       e.target.classList.add('spin');
       printError('#fieldMessage', '');
    
      // Get Selected Specialities
          function getSelectedSpecialities() {
            const checkboxes = document.querySelectorAll(
              'input[name="option"]:checked'
            );
            const selectedSpecialities = Array.from(checkboxes).map(
              (checkbox) => checkbox.value
            );
            return selectedSpecialities;
          }
    
    // Update Fields
    const specialities = getSelectedSpecialities();

    const data = {
      specialities: specialities || [],
      introduction: {
        about: charLimit120.value || "",
        quote: charLimit65.value || "",
        philosophy: charLimit400.value || "",
      },
    };
    
    const response = await sendRequest(`stylist/update`, {
         method: "PUT",
         authenticate: true,
         body: JSON.stringify(data),
    });

     if (response instanceof Error) {
        printError('#fieldMessage', response);
        e.target.classList.remove('spin');
        return;
     }

    printError('#fieldMessage', 'Profile Updated Successfully', 'success');
    e.target.classList.remove('spin');
    
  }
  
  const deleteFavImage = (element) => {
   for( el of element ) {
    el.addEventListener( 'click', async function(e){
      e.stopPropagation();
     e.currentTarget.closest('.remove-main').remove();
      const image = e.currentTarget.getAttribute('data-id');
      
      const bodyData = {image}
      const body = JSON.stringify(bodyData);

      const response = await sendRequest('stylist/delete-fav-image', {
         method: "POST",
         body: body,
         authenticate: true
      });

      if (response instanceof Error) {
        alert('Image Error, Refresh your page Please!');
        return;
      }
       
    });
   }
  } 

   const deleteInspireImage = (element) => {
   for( el of element ) {
    el.addEventListener( 'click', async function(e){
      e.stopPropagation();
     e.currentTarget.closest('.remove-main').remove();
      const image = e.currentTarget.getAttribute('data-id');
      
      const bodyData = {image}
      const body = JSON.stringify(bodyData);

      const response = await sendRequest('stylist/delete-inspiration-image', {
         method: "POST",
         body: body,
         authenticate: true
      });

      if (response instanceof Error) {
        alert('Image Error, Refresh your page Please!');
        return;
      }
       
    });
   }
  }  
  
  document.addEventListener("closeInspire", () => {
    deleteInspireImage(document.querySelectorAll(".closeInspireImage"));
  });
  
  for (const img of favouriteImages) {
    const deleteSrc = img.split('.com');
    const iconClose = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.866 13.3946L13.3945 13.866C13.1342 14.1263 12.7121 14.1263 12.4517 13.866L7.03064 8.44484L1.60944 13.8659C1.34914 14.1263 0.927022 14.1263 0.666672 13.8659L0.195262 13.3945C-0.0650875 13.1342 -0.0650875 12.7121 0.195262 12.4517L5.61644 7.03064L0.195262 1.60944C-0.0650875 1.34914 -0.0650875 0.927022 0.195262 0.666672L0.666662 0.195272C0.927012 -0.065078 1.34914 -0.065078 1.60944 0.195272L7.03064 5.61644L12.4517 0.195262C12.7121 -0.0650875 13.1342 -0.0650875 13.3945 0.195262L13.866 0.666662C14.1263 0.927012 14.1263 1.34914 13.866 1.60944L8.44484 7.03064L13.866 12.4517C14.1263 12.7121 14.1263 13.1342 13.866 13.3946Z" fill="black"/></svg>`;
    imageContainer.innerHTML = `<div class="remove-main" style="position: relative;"><img class="uploadedImage" src=${img} alt="" /><div class="removeBtn closeFavImage" data-id="${deleteSrc[1]}">${iconClose}</div></div>`
      + imageContainer.innerHTML;
    deleteFavImage(document.querySelectorAll(".closeFavImage"));
  }

  for (const img of inspirationImages) {
    const deleteSrc = img.split('.com');
    const iconClose = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.866 13.3946L13.3945 13.866C13.1342 14.1263 12.7121 14.1263 12.4517 13.866L7.03064 8.44484L1.60944 13.8659C1.34914 14.1263 0.927022 14.1263 0.666672 13.8659L0.195262 13.3945C-0.0650875 13.1342 -0.0650875 12.7121 0.195262 12.4517L5.61644 7.03064L0.195262 1.60944C-0.0650875 1.34914 -0.0650875 0.927022 0.195262 0.666672L0.666662 0.195272C0.927012 -0.065078 1.34914 -0.065078 1.60944 0.195272L7.03064 5.61644L12.4517 0.195262C12.7121 -0.0650875 13.1342 -0.0650875 13.3945 0.195262L13.866 0.666662C14.1263 0.927012 14.1263 1.34914 13.866 1.60944L8.44484 7.03064L13.866 12.4517C14.1263 12.7121 14.1263 13.1342 13.866 13.3946Z" fill="black"/></svg>`;
    imageInspirationContainer.innerHTML = `<div class="remove-main" style="position: relative;"><img class="uploadedImage" src=${img} alt="" /><div class="removeBtn closeInspireImage" data-id="${deleteSrc[1]}">${iconClose}</div></div>`
      + imageInspirationContainer.innerHTML;
    deleteInspireImage(document.querySelectorAll(".closeInspireImage"));
  }


}

//get user 
const getUser = async () => {
const response = await sendRequest('me', {
  authenticate: true,
});
 
  if (response instanceof Error) {
    window.location.href = '/account/logout';
    return;
  }
  localStorage.setItem('stylistId', response.id);
  document.querySelector(".page_profile_content").setAttribute("stylist-id", response.id);
  
  const { meta={}, firstName='', email='', id='', lastName='' } = response;

  profileAvatar(id, meta?.avatarUrl, firstName, `${firstName} ${lastName}`, meta?.shopifyProductHandle );
  stylistLogout();
  
  if (document.querySelector('#stylist-profile-page')) {
      profileData(meta?.favouriteImages, meta?.inspirationImages, meta?.introduction, meta?.specialities);
  }
  if (document.querySelector('#stylist-services-page')) {
      setServices(id, meta.shopifyProductHandle);
      setCommission();
  }
  if (document.querySelector('#stylist-account-page')) {
    accountFormFields(firstName, lastName, email, meta.socialMediaAccounts);
    connectStripe();
  }
  if (document.querySelector('#stylist-clients-page')) {
    stylistClients(id);
  }
  if (document.querySelector('#stylist-message-page')) {
    stylistMessaging();
  }
  if (document.querySelector('#stylist-myboard-page')) {
    stylistMyboard();
  }
  
};

// Profile avatar update
const profileAvatar = async (id, url, fName, name, shopifyProductHandle) => {
  const profileImg = document.getElementById("profileImg");
  const accountImg = document.getElementById("accountImg");
  const headImg = document.getElementById("head__img");
  const uploadProfileBtn = document.getElementById("upload_profile_btn");
  const fileInput = document.getElementById("fileInput");
  const userName = document.getElementById("user-name");
  const headUsername = document.getElementById("head__username");
  const headLinkDashboard = document.getElementById("head__linkDashboard");
  const stylist_product_url = document.getElementById("stylist_product_url");

  stylist_product_url.setAttribute("href", `/products/${shopifyProductHandle}`);
  headLinkDashboard.setAttribute("href", `/pages/stylist-clients?tab3`);

  userName.innerHTML = name;
  headUsername.innerHTML = fName;

  if (url !== "") {
    profileImg.setAttribute("src", url);
    accountImg.setAttribute("src", url);
    //headImg.setAttribute("src", url);
  } else {
    profileImg.style.display = "none";
  }

  uploadProfileBtn.onclick = () => {
    fileInput.click();
  };

  fileInput.onchange = async () => {
    const file = fileInput.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG and PNG images are allowed.");
      fileInput.value = "";
      return;
    }

    const maxSize = 2 * 1024 * 1024;
    if (file.size > maxSize) {
      alert("Oops! This file is too large. Please upload an image under 2 MB and ensure it’s saved as a JPG or PNG format.");
      fileInput.value = "";
      return;
    }

    uploadProfileBtn.classList.add("spin");

    const formData = new FormData();
    formData.append("profileImage", file);

    try {
      const response = await sendRequest("stylist/profile-image", {
        method: "POST",
        body: formData,
        authenticate: true,
      });

      //console.log("Raw upload response:", response);

      if (response instanceof Error) {
        //console.error("Server returned error object:", response);
        alert(response.message || "Upload failed on server.");
        return;
      }

      const avatarUrl = response.avatarUrl || response.url;
      if (!avatarUrl) {
        //console.error("No avatarUrl or url in response:", response);
        alert("Upload succeeded but no image URL returned.");
        return;
      }

      //console.log("Upload success:", avatarUrl);

      if (profileImg) profileImg.setAttribute("src", avatarUrl);
      if (accountImg) accountImg.setAttribute("src", avatarUrl);
      if (headImg) headImg.setAttribute("src", avatarUrl);

    } catch (error) {
      //console.error("Caught upload error:", error);
      alert("Error uploading image. Please try again.");
    } finally {
      uploadProfileBtn.classList.remove("spin");
      fileInput.value = ""; // Reset input cleanly
    }
  };

};



//stylist messaging 
const stylistMessaging = () => {
//stylist customers
// const getCustomers = async () => {

//     const response = await sendRequest ('stylist/customers/get',{ 
//       method: "GET",
//       authenticate: true
//     });

//     const all_clients = document.getElementById("all_clients");
//     response.list.forEach(function (ls) {
//       all_clients.innerHTML += `<div class="client_profile" data-id="${ls.id}">
//               <div class="client_img">
//               <img class="gm_img" src="${ls.avatarUrl}" /></div>
//               <h3>${ls.firstName} ${ls.lastName}</h3>
//             </div>`;
//     });

// }; 
// getCustomers();
}

function resetMyComments() {
     //console.log("testinggrid")
     const grid = $('div.tab_grid_content.activeGridContent');
     //console.log("testinggridgrid" , grid)
    //console.log("testinggridgridlen" , grid.length)
   
    grid.find('.grid_img').each(function () {
      //console.log("comment>>>>22" ,$(this).next('.editable__comment:first').text() )
      $(this).next('.editable__comment:first').text('');
      $(this).next('.editable__comment:first').text("Add a comment");
      //console.log("comment>>>>" ,$(this).next('.editable__comment:first').text() )
    });
  }

//stylist messaging 
const stylistMyboard = () => {
  const createMyBoard = document.querySelector('.create_mystyleBtn');
  const shopping_list = document.getElementById('shopping__list');
  createMyBoard.addEventListener('click', function (e) {
  resetMyComments()
  var gridElements = document.querySelectorAll('.grid_tablink');
    gridElements.forEach(function(element) {
        element.style.display = 'block';
    });
    shopping_list.style.display = 'block';
    const style_modal = document.getElementById('create_board_modal');
    printError('#board__error', '');

    const gridImg = document.querySelectorAll('.grid_img');
    for (g of gridImg) {
      g.innerHTML = '';
      g.classList.remove('el-dropped');
    }
    showContentForCreate();
    shoppingList('');
    shopping_list.style.display = 'none';
    document.getElementById('myPreviewContainer').innerHTML = '';
    style_modal.style.display = 'block';
    style_modal.setAttribute('data-type', 'createMyBoard');
    document.getElementById('titleInputStyleboard').focus();
    createMyStyleboard();
  });

  //show some element for create {
  const showContentForCreate = () => {
    document.getElementById('titleInputStyleboard').removeAttribute('readonly');
    document.getElementById('titleInputStyleboard').value = '';
    document.getElementById('descInputStyleboard').removeAttribute('readonly');
    document.getElementById('descInputStyleboard').value = '';
    document.getElementById('save_styleboard').style.display = 'flex';
    document.querySelector('.styleboard_grid_box').style.display = 'flex';
    document.getElementById('myboardfile').removeAttribute('disabled');
    if(document.querySelector('.styleboard-logo.image_added')){
      document.querySelector('.styleboard-logo.image_added').classList.remove('image_added');
    }
    document.getElementById('myboardfile').value='';
  };

  //create styleboard
  const createMyStyleboard = () => {
    const save_styleboard = document.getElementById('save_styleboard');
    save_styleboard.onclick = async (e) => {
      e.target.disabled = true;
  
      const titleValue = document.getElementById('titleInputStyleboard').value.trim();
      const descriptionValue = document.getElementById('descInputStyleboard').value.trim();
      let gridTablink = document.querySelectorAll('.grid_tablink');
      const logoFile = document.getElementById('myboardfile').value;
  
      if (titleValue === '') {
        printError('#board__error', 'Board title is required');
        e.target.disabled = false;
        return;
      }
      if (logoFile === '') {
        printError('#board__error', 'Featured image is required');
        e.target.disabled = false;
        return;
      }
  
      e.target.classList.add('spin');
  
      let grid_id;
      let grid_label = '';
      for (let grid of gridTablink) {
        if (grid.classList.contains('active_grid')) {
          grid_label = grid.getAttribute('data-label');
        }
      }
      if (grid_label.trim() === 'Grid 1') {
        grid_id = '6578413cb97117e2c84d80ca';
      }
      if (grid_label.trim() === 'Grid 2') {
        grid_id = '65784157b97117e2c84d80cc';
      }
      if (grid_label.trim() === 'Grid 3') {
        grid_id = '6578416db97117e2c84d80ce';
      }
      if (grid_label.trim() === 'Grid 4') {
        grid_id = '660fd52cde8cb7a2b70077c2';
      }
  
      function buildCellsList() {
        const grid = $('div.tab_grid_content.activeGridContent');
  
        if (!grid.length) {
          return [];
        }
  
        const collection = [];
  
        grid.find('.el-dropped').each(function () {
          const positionId = $(this).data('id');
          const type = $(this).find('img').length ? 'picture' : 'text';
  
          const comment = $(this).next('.editable__comment:first').text() || '';
          const data = {};
  
          if (type === 'picture') {
            data.imageId = $(this).find('img').attr('src').replace(/^.+\?/, '');
          } else if (type === 'text') {
            const heading = $(this).find('h2').text().trim() || '';
            const description = $(this).find('h3').text().trim() || '';
  
            if (heading) data['heading'] = heading;
            if (description) data['description'] = description;
          }
  
          collection.push({ positionId, type, data, comment });
        });
  
        return collection;
      }
  
      const payload = {
        gridId: grid_id,
        title: titleValue,
        description: descriptionValue,
        cells: buildCellsList(),
      };
  
      const timeout = (ms) => {
        return new Promise((_, reject) => setTimeout(() => reject(new Error("timeout")), ms));
      };
  
      try {
        //console.log('Payload:', JSON.stringify(payload));
  
        // Set a timeout of 30 seconds for the request
        const result = await Promise.race([
          sendRequest('public-styleboards/create', {
            method: 'POST',
            body: JSON.stringify(payload),
            authenticate: true,
          }),
          timeout(30000) // 30 seconds timeout
        ]);
  
        if (result instanceof Error) {
          //console.error('Server Response:', result);
          throw new Error(`Failed to save style board: ${result.message}`);
        }
  
        const formData = new FormData();
        formData.append("logo", document.getElementById('myboardfile').files[0]);
  
        // Set a timeout of 30 seconds for the request
        const result2 = await Promise.race([
          sendRequest(`public-styleboards/${result.boardId}/logo`, {
            method: 'POST',
            body: formData,
            authenticate: true,
          }),
          timeout(30000) // 30 seconds timeout
        ]);
  
        if (result2 instanceof Error) {
          //console.error('Logo Upload Error:', result2);
          throw new Error(`Failed to upload logo: ${result2.message}`);
        }
  
        e.target.classList.remove('spin');
  
        setTimeout(() => {
          printError('#board__error', 'Board created successfully', 'success');
          getMyboards();
  
          document.getElementById('titleInputStyleboard').value = '';
          document.getElementById('descInputStyleboard').value = '';
          document.getElementById('myboardfile').value = '';
          e.target.disabled = false;
  
          const grid = $('div.tab_grid_content.activeGridContent');
          grid.find('.el-dropped img').remove();
          grid.find('.el-dropped').removeClass('el-dropped');
          grid.find('.sb-delete-img').remove();
  
          grid.find('.editable__comment').text('Add a comment');
          grid.find('h2.editable__text').text('');
          grid.find('h3.editable__text').text('');
  
          document.getElementById('myboardfile').value = '';
          $('.styleboard-logo').removeClass('image_added');
          $('#myPreviewContainer').empty();
        }, 2000);
  
      } catch (error) {
        //console.error('Error:', error.message);
  
        if (error.message.includes('timeout')) {
          printError('#board__error', 'The request is taking too long. Please try again with a smaller image or check your network connection.');
        } else if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
          printError('#board__error', 'Network issue: Please check your internet connection and try again.');
        } else {
          printError('#board__error', error.message || 'An unexpected error occurred');
        }
        
        e.target.classList.remove('spin');
        e.target.disabled = false;
      }
    };
  };
  

  // Get MyBoard 
  const grid = document.getElementById("my_styleboard_grid");
  const getMyboards = async () => {
    const response = await sendRequest("public-styleboards/list", {
      method: "GET",
      authenticate: true,
    });
    if (response instanceof Error) {
      printError('#myboard_error', response);
      return;
    }
    const data = response;
    grid.innerHTML = '';
    if( data.length > 0 ){
      data?.forEach(function (dat, index) {
        
  
           grid.innerHTML += `<div class="my_styleboard_profile">
                  <div class="my_styleboard_img">
                  ${dat.logoUrl ? `<img class="gm_img" src="${dat.logoUrl}" alt="board image" />` : `<img class="gm_img" src="https://cdn.shopify.com/s/files/1/0826/0318/0316/files/no-img.jpg?v=1716453799" alt="board image" />`}
                  </div>
                  <div class="my_styleboard_content">
                    <h2>${dat.title}</h2>
                    <div class="my_styleboard_review">
                      
                    </div>
                    <div class="btn_group">
                      <button  data-board-id="${dat.boardId}" data-grid-id="${dat.gridId}" class="view_styleboard">View</button>
                      <button data-board-id="${dat.boardId}" class="edit_styleboard">Edit</button>
                      <button data-board-id="${dat.boardId}" class="delete_styleboard"><i class="fa fa-circle-o-notch fa-spin spinner"></i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" class="cross">
                        <path d="M13.866 13.3946L13.3945 13.866C13.1342 14.1263 12.7121 14.1263 12.4517 13.866L7.03064 8.44484L1.60944 13.8659C1.34914 14.1263 0.927022 14.1263 0.666672 13.8659L0.195262 13.3945C-0.0650875 13.1342 -0.0650875 12.7121 0.195262 12.4517L5.61644 7.03064L0.195262 1.60944C-0.0650875 1.34914 -0.0650875 0.927022 0.195262 0.666672L0.666662 0.195272C0.927012 -0.065078 1.34914 -0.065078 1.60944 0.195272L7.03064 5.61644L12.4517 0.195262C12.7121 -0.0650875 13.1342 -0.0650875 13.3945 0.195262L13.866 0.666662C14.1263 0.927012 14.1263 1.34914 13.866 1.60944L8.44484 7.03064L13.866 12.4517C14.1263 12.7121 14.1263 13.1342 13.866 13.3946Z" fill="black"></path>
                      </svg>
                      </button>
                      <a class="shareable_link" href="/pages/my-styleboard?boardId=${dat.boardId}" target="_blank">Shareable Link</a>
                    </div>
                  </div>
                </div>
              </div>`
  
        
      });
      }
    deleteMyStyleBoard();
    view_edit();
  };
  getMyboards();
  // Display recommendation
  // async function displayRecommendations(inspirationBoardId) {
  //   const shoppingProductList = document.querySelector(
  //     '.shopping_product_list'
  //   );
  //   shoppingProductList.innerHTML = '';
  //   const response = await sendRequest(
  //     `styleboard-products/${inspirationBoardId}/list`,
  //     {
  //       method: 'GET',
  //       authenticate: true,
  //     }
  //   );
  //     const responseData = response["All"];
  //   responseData?.forEach((recommendation) => {
  //     // const card = document.createElement("div");
  //     // card.className = "rec_product_card";
  //     shoppingProductList.innerHTML =
  //       `
  //                                   <div class="rec_product_card">
  //                                   <div class="rec_product_img"><img src="${recommendation?.coverUrl}" /></div>
  //                                   <div class="rec_product_content">
  //                                     <h3 class="rec_product">${recommendation.title}</h3>
  //                                     <h4 class="rec_product_rate">$${recommendation.price}</h4>
  //                                     <button class="rec_close_button delete_recProduct" data-board-id=${inspirationBoardId} data-id="${recommendation.id}"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
  //                                         <path d="M13.866 13.3946L13.3945 13.866C13.1342 14.1263 12.7121 14.1263 12.4517 13.866L7.03064 8.44484L1.60944 13.8659C1.34914 14.1263 0.927022 14.1263 0.666672 13.8659L0.195262 13.3945C-0.0650875 13.1342 -0.0650875 12.7121 0.195262 12.4517L5.61644 7.03064L0.195262 1.60944C-0.0650875 1.34914 -0.0650875 0.927022 0.195262 0.666672L0.666662 0.195272C0.927012 -0.065078 1.34914 -0.065078 1.60944 0.195272L7.03064 5.61644L12.4517 0.195262C12.7121 -0.0650875 13.1342 -0.0650875 13.3945 0.195262L13.866 0.666662C14.1263 0.927012 14.1263 1.34914 13.866 1.60944L8.44484 7.03064L13.866 12.4517C14.1263 12.7121 14.1263 13.1342 13.866 13.3946Z" fill="black"/>
  //                                         </svg>
  //                                     </button>
  //                                     <div class="rec_button_main">
  //                                     <button class="rec_product_link" onclick="window.open('${recommendation.pageUrl}')">Shop now <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  //                                       <path fill-rule="evenodd" clip-rule="evenodd" d="M6.96028 6.64234C7.17996 6.86202 7.17996 7.21812 6.96028 7.43779L1.22541 13.1727C1.00573 13.3923 0.649631 13.3923 0.429956 13.1727L0.164756 12.9075C-0.0549187 12.6878 -0.0549187 12.3317 0.164756 12.112L5.23671 7.04007L0.164756 1.96812C-0.0549186 1.74844 -0.0549186 1.39234 0.164756 1.17267L0.429956 0.907467C0.649631 0.687792 1.00573 0.687792 1.22541 0.907467L6.96028 6.64234Z" fill="black"/>
  //                                       </svg>
  //                                       </button>
  //                                     <button class="rec_update_button update_recProduct" data-board-id=${inspirationBoardId} data-id="${recommendation.id}" data-title="${recommendation.title}" data-cover="${recommendation?.coverUrl}" data-page="${recommendation.pageUrl}" data-price="${recommendation.price}" data-brand="${recommendation.brandName}">Update</button>
  //                                     </div>
  //                                   </div></div>
  //                               ` + shoppingProductList.innerHTML;
  //   });
  // }
  // Style Session Styleboard Recommendation
  // Display recommendation
     async function displayRecommendations(inspirationBoardId) {
        const shoppingProductList = document.querySelector(".shopping_product_list");
     const stylistId = document.querySelector(".page_profile_content").getAttribute("stylist-id");
         
          shoppingProductList.innerHTML = '';
          const response = await sendRequest(`styleboard-products/${inspirationBoardId}/${stylistId}/list`,
        {
          method: "GET",
          authenticate: true
        });

        if (response instanceof Error) {
            return;
        }


         window.handleMyDeepLink = async function(productLink) {
       if (!productLink || productLink === "Not provided") {
         alert('Deep link not provided');
         return;
       }
       const stylistId = document.querySelector(".page_profile_content").getAttribute("stylist-id");
       const parsedUrl = new URL(productLink);
       const mainWebsiteLink  = parsedUrl.origin;
      if (productLink == "Not provided") {
            alert('Deep link not provided');
            return
        } else {
           const response = await sendRequest(`links/generate?site=${mainWebsiteLink}&stylistID=${stylistId}&pageUrl=${productLink}`,
              {
                method: "GET",
                authenticate: true,
              }
            );
  
            if (response instanceof Error) {
              printError('#rec_message_error', response);
              e.classList.remove('spin');
              return;
             }
            if(response.msg){
               window.open(productLink)
              return
            }
            window.open(response)
        }
    };
       const titleKeys = Object.keys(response)
        titleKeys.forEach((title)=> {
             const cards = response[title]
            const categoryDiv = document.createElement("div"); 
            categoryDiv.classList.add("category-div");
             categoryDiv.innerHTML = `<div class="category-title"><h1>${title}</h1></div>`;
             const categoryCardsDiv = document.createElement("div"); 
            categoryCardsDiv.classList.add("category-cards-div");
            categoryCardsDiv.setAttribute("data-category-id", cards[0]?.categoryId || "-")
        const editType = document.getElementById("create_board_modal").getAttribute('data-type');
             cards?.forEach((recommendation) => {
                    categoryCardsDiv.innerHTML = categoryCardsDiv.innerHTML + `
                      <div class="rec_product_card" data-product-id="${recommendation?.id}">
                        <div class="rec_product_img"><img src="${recommendation?.coverUrl}" /></div>
                        <div class="rec_product_content">
                          <h3 class="rec_product">${recommendation.title}</h3>
                          <h4 class="rec_product_rate">$${recommendation.price}</h4>
                          <button class="rec_close_button delete_recProduct" data-board-id=${inspirationBoardId} data-id="${recommendation.id}"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                              <path d="M13.866 13.3946L13.3945 13.866C13.1342 14.1263 12.7121 14.1263 12.4517 13.866L7.03064 8.44484L1.60944 13.8659C1.34914 14.1263 0.927022 14.1263 0.666672 13.8659L0.195262 13.3945C-0.0650875 13.1342 -0.0650875 12.7121 0.195262 12.4517L5.61644 7.03064L0.195262 1.60944C-0.0650875 1.34914 -0.0650875 0.927022 0.195262 0.666672L0.666662 0.195272C0.927012 -0.065078 1.34914 -0.065078 1.60944 0.195272L7.03064 5.61644L12.4517 0.195262C12.7121 -0.0650875 13.1342 -0.0650875 13.3945 0.195262L13.866 0.666662C14.1263 0.927012 14.1263 1.34914 13.866 1.60944L8.44484 7.03064L13.866 12.4517C14.1263 12.7121 14.1263 13.1342 13.866 13.3946Z" fill="black"/>
                              </svg>
                          </button>
                          <div class="rec_button_main">
                          <button class="rec_product_link" onclick="handleMyDeepLink('${recommendation.pageUrl}')">Shop now <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.96028 6.64234C7.17996 6.86202 7.17996 7.21812 6.96028 7.43779L1.22541 13.1727C1.00573 13.3923 0.649631 13.3923 0.429956 13.1727L0.164756 12.9075C-0.0549187 12.6878 -0.0549187 12.3317 0.164756 12.112L5.23671 7.04007L0.164756 1.96812C-0.0549186 1.74844 -0.0549186 1.39234 0.164756 1.17267L0.429956 0.907467C0.649631 0.687792 1.00573 0.687792 1.22541 0.907467L6.96028 6.64234Z" fill="black"/>
                          </svg>
                          </button>
                          <button class="rec_update_button update_recProduct" data-board-id=${inspirationBoardId} data-id="${recommendation.id}" data-title="${recommendation.title}" data-cover="${recommendation?.coverUrl}" data-page="${recommendation.pageUrl}" data-price="${recommendation.price}" data-brand="${recommendation.brandName}" data-category="${title}">Update</button>
                          </div>
                        </div>
                      </div>
                ` 
               categoryDiv.append(categoryCardsDiv)
        if (editType == 'edit') {
               // Drag and Drop 
                const dropItems = categoryDiv.querySelector('.category-cards-div');
                new Sortable(dropItems, {
                    animation: 350,
                    chosenClass: "sortable-chosen",
                    dragClass: "sortable-drag",
                    store: {
                      // We keep the order of the list
                      set: (sortable) =>{
                          const order = sortable.toArray()
                          localStorage.setItem(sortable.options.group.name, order.join('|'))
                          handleMySorting(sortable);
                      },
                
                      // We get the order of the list
                      get: (sortable) =>{
                          const order = localStorage.getItem(sortable.options.group.name)
                          return order ? order.split('|') : []
                      }
                    }
                });
        }
             });
          shoppingProductList.append(categoryDiv);
        })
    }

  // Sort Products 
    async function sortMyProducts(categoryId, productIds) {
       const response = await sendRequest(`styleboard-products/sort`,
        {
          method: "POST",
          authenticate: true,
          body: JSON.stringify({
                  categoryId: categoryId,
                  products: productIds
              })
        });
         if (response instanceof Error) {
            return;
         }
          alert("Sorting implemented successfully.");
      }
  // Handle Sorting Products 
    function handleMySorting(sortable) {
          const order = sortable.toArray();
          const categoryId = sortable.el.getAttribute('data-category-id');
          const productIds = Array.from(sortable.el.querySelectorAll('.rec_product_card')).map(card => card.getAttribute('data-product-id'));
          sortMyProducts(categoryId, productIds);
      }

  // Save Product
  const saveProduct = document.getElementById('save__product');
  const save__moreProduct = document.getElementById('save__moreProduct');
  saveProduct?.addEventListener('click', function (e) {
    addRecommendation(e, true);
  });
  save__moreProduct?.addEventListener('click', function (e) {
    addRecommendation(e, false);
  });

  // Add Recommendation
  const addRecommendation = async (e, close) => {
    printError('#rec_message_error', '');
    const modalErrorMessage = document.getElementById('rec_message_error');
    const title = document.getElementById('titleInput')?.value;
    const pageUrl = document.getElementById('productUrlInput')?.value;
    const coverUrl = document.getElementById('imageUrlInput')?.value;
    const price = document.getElementById('priceInput')?.value;
    const brandName = document.getElementById('brandInput')?.value;
    const categoryName = document.getElementById("categoryInput")?.value;

    modalErrorMessage.innerHTML = '';

    if (!title || !pageUrl || !coverUrl || !price || !brandName) {
      modalErrorMessage.innerHTML = 'All fields are required';
      return;
    }

    e.target.classList.add('spin');
    const inspirationBoardId = $('#board__id').val() || '';
    const bodyData = {
      inspirationBoardId,
      title,
      pageUrl,
      coverUrl,
      price,
      brandName,
      categoryName
    };
    let bodyPayload = JSON.stringify(bodyData);
    const response = await sendRequest('styleboard-products/add', {
      method: 'POST',
      body: bodyPayload,
      authenticate: true,
    });

    if (response instanceof Error) {
      printError('#rec_message_error', response);
      e.target.classList.remove('spin');
      return;
    }

    displayRecommendations($('#board__id').val());

    printError(
      '#rec_message_error',
      'Recommendation created successfully',
      'success'
    );
    e.target.classList.remove('spin');
    document.getElementById('titleInput').value = '';
    document.getElementById('productUrlInput').value = '';
    document.getElementById('imageUrlInput').value = '';
    document.getElementById('priceInput').value = '';
    document.getElementById('brandInput').value = '';
    if (close) {
      rec_product_modal.style.display = 'none';
    }
    setTimeout(function () {
      printError('#rec_message_error', '');
    }, 2000);
  };

  // Update Modal
  $(document).on('click', '.update_recProduct', async function () {
    $('#updateModal').css('display', 'flex');
    printError('#update_message_error', '');
    const id = $(this).attr('data-id');
    const inspirationBoardId = $(this).attr('data-board-id');
    const title = $(this).attr('data-title');
    const coverUrl = $(this).attr('data-cover');
    const pageUrl = $(this).attr('data-page');
    const price = $(this).attr('data-price');
    const brandName = $(this).attr('data-brand');
    const categoryName = $(this).attr('data-category');
    $('#BoardIdInputUpdate').val(inspirationBoardId);
    $('#IdInputUpdate').val(id);
    $('#productUrlInputUpdate').val(pageUrl);
    $('#imageUrlInputUpdate').val(coverUrl);
    $('#titleInputUpdate').val(title);
    $('#priceInputUpdate').val(price);
    $('#brandInputUpdate').val(brandName);
    $('#categoryInputUpdate').val(categoryName);
  });
  
  // Close Update Modal
  $(document).on('click', '.close_update_product', function () {
    $('#updateModal').hide();
  });

  // Confirm Modal
  $(document).on('click', '.confirm_update', async function () {
    printError('#update_message_error', '');
    const id = $('#IdInputUpdate').val();
    const inspirationBoardId = $('#BoardIdInputUpdate').val();
    let bodyData = {
      id: id,
      inspirationBoardId: inspirationBoardId,
      title: $('#titleInputUpdate').val(),
      pageUrl: $('#productUrlInputUpdate').val(),
      coverUrl: $('#imageUrlInputUpdate').val(),
      price: $('#priceInputUpdate').val(),
      brandName: $('#brandInputUpdate').val(),
      categoryName: $('#categoryInputUpdate').val()
    };
    let body = JSON.stringify(bodyData);
    const response = await sendRequest(`styleboard-products/update`, {
      method: 'POST',
      body,
      authenticate: true,
    });

    if (response instanceof Error) {
      printError('#update_message_error', response);
      return;
    }
    displayRecommendations(inspirationBoardId);
    printError(
      '#update_message_error',
      'Recommendation updated successfully.',
      'success'
    );
  });

  // Delete Modal
  let recProductId = '';
  $(document).on('click', '.delete_recProduct', function () {
    document.getElementById('confirmModal').style.display = 'flex';
    recProductId = $(this).attr('data-id');
  });

  // Close Confirm Modal
  $(document).on('click', '.close_confirm_modal', function () {
    $('#confirmModal').hide();
  });

  // Delete Modal
  $(document).on('click', '.confirm_del', async function () {
    const response = await sendRequest(
      `styleboard-products/${recProductId}/remove`,
      {
        method: 'DELETE',
        authenticate: true,
      }
    );

    if (response instanceof Error) {
      printError('#rec_productError', response);
      return;
    }

    displayRecommendations($('#board__id').val());
    document.getElementById('confirmModal').style.display = 'none';
  });

  // Shopping List
  const shoppingList = (inspirationBoardId) => {
    if(inspirationBoardId != ''){
      const board__id = document.getElementById('board__id');
      board__id.value = inspirationBoardId;
    }
    const board_addProduct = document.getElementById('board_addProduct');
    const rec_product_modal = document.getElementById('rec_product_modal');

    board_addProduct.onclick = () => {
      rec_product_modal.style.display = 'flex';
      const shoppingProductList = document.querySelector(
        '.shopping_product_list'
      );
      // shoppingProductList.innerHTML = '';
    };

    displayRecommendations(inspirationBoardId);
  };
  
  // Close Session Modal
  document.querySelector('.rec_close_btn').addEventListener('click', function(){
    document.getElementById("create_board_modal").style.display = "none";
    // Reset Grid 
    const tabLinks = document.querySelectorAll('.grid_tablink');
    const tabGridContent = document.querySelectorAll('.tab_grid_content');
    tabLinks.forEach(function(tabLink, index) {
        if (index === 0) {
            tabLink.classList.add('active_grid');
        } else {
            tabLink.classList.remove('active_grid');
        }
        tabLink.style.display = 'block';
    });

    tabGridContent.forEach(function(tabGrid, index) {
        if (index === 0) {
            tabGrid.classList.add('activeGridContent');
        } else {
            tabGrid.classList.remove('activeGridContent');
        }
    });
    
  });
  window.onclick = function (event) {
    var modal = document.getElementById("create_board_modal");
    if (event.target == modal) {
      modal.style.display = "none";
    
        // Reset Grid 
        const tabLinks = document.querySelectorAll('.grid_tablink');
        const tabGridContent = document.querySelectorAll('.tab_grid_content');
        tabLinks.forEach(function(tabLink, index) {
            if (index === 0) {
                tabLink.classList.add('active_grid');
            } else {
                tabLink.classList.remove('active_grid');
            }
            tabLink.style.display = 'block';
        });
    
        tabGridContent.forEach(function(tabGrid, index) {
            if (index === 0) {
                tabGrid.classList.add('activeGridContent');
            } else {
                tabGrid.classList.remove('activeGridContent');
            }
        });
     }
  };

  //upload logo
  document.getElementById('myboardfile').addEventListener('change', function(event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function(e) {
        const image = document.createElement('img');
        image.src = e.target.result;
        document.getElementById('myPreviewContainer').innerHTML = '';
        document.getElementById('myPreviewContainer').appendChild(image);
        document.querySelector('.styleboard-logo').classList.add('image_added');
      };
      reader.readAsDataURL(file);
    }
  });

  // Delete Style Modal
  const deleteMyStyleBoard = () => {
    var delete_btns = document.querySelectorAll('.delete_styleboard');
    delete_btns?.forEach(function (btn) {
      btn.addEventListener('click', async function(){
        let board_id = this.getAttribute('data-board-id');
        if(!confirm("Are you sure you want to delete?")){
          return false;
        }
        this.classList.add('spin');
        const response = await sendRequest(`public-styleboards/${board_id}/remove`, {
          method: "Delete",
          authenticate: true,
        });
        if (response instanceof Error) {
          printError('#myboard_error', response);
          return;
        }
        getMyboards();
      });
    })
  }

  // View Edit
  const view_edit = () => {
    const viewElement = document.querySelectorAll('.view_styleboard');
    const editElement = document.querySelectorAll('.edit_styleboard')
    for (const el of viewElement) {
      el.addEventListener('click', function (e) {
        const style_modal = document.getElementById('create_board_modal');
        const board_id = e.target.getAttribute('data-board-id');
        // const customer_id = e.target.getAttribute('data-id');
        printError('#board__error', '');
        style_modal.setAttribute('data-type', 'viewMyBoard');
        shopping_list.style.display = 'block';
        style_modal.style.display = 'block';
        viewStyleboard(board_id, 'view');
        shoppingList(board_id);
      });
    }
    for (const el of editElement) {
      el.addEventListener('click', function (e) {
        const style_modal = document.getElementById('create_board_modal');
        const board_id = e.target.getAttribute('data-board-id');
        printError('#board__error', '');

        shopping_list.style.display = 'block';
        style_modal.style.display = 'block';
        style_modal.setAttribute('data-type', 'edit');
        viewStyleboard(board_id, 'edit');
        updateStyleboard(board_id);
        shoppingList(board_id);
      });
    }
  }

  //update styleboard
  const updateStyleboard = (board_id) => {
    const save_styleboard = document.getElementById('save_styleboard');
    save_styleboard.onclick = async (e) => {
      const titleValue = document
        .getElementById('titleInputStyleboard')
        .value.trim();
      const descriptionValue = document
        .getElementById('descInputStyleboard')
        .value.trim();
      const gridTablink = document.querySelectorAll('.grid_tablink');

      if (titleValue === '') {
        printError('#board__error', 'Board title is required');
        return;
      }

      //loading submit button
      e.target.classList.add('spin');

      let grid_id;
      let grid_label = '';
      for (let grid of gridTablink) {
        if (grid.classList.contains('active_grid')) {
          grid_label = grid.getAttribute('data-label');
        }
      }
  
      if (grid_label.trim() == 'Grid 1') {
        grid_id = '6578413cb97117e2c84d80ca';
      }
      if (grid_label.trim() == 'Grid 2') {
        grid_id = '65784157b97117e2c84d80cc';
      }
      if (grid_label.trim() == 'Grid 3') {
        grid_id = '6578416db97117e2c84d80ce';
      }
       if (grid_label.trim() == 'Grid 4') {
        grid_id = '660fd52cde8cb7a2b70077c2';
      }

      function buildCellsList() {
        const grid = $('div.tab_grid_content.activeGridContent');

        if (!grid.length) {
          return [];
        }

        const collection = [];

        grid.find('.grid_img').each(function () {
          const id = $(this).data('cell-id');
          const positionId = $(this).data('id');
          let type = 'none';
          const comment = $(this).find('.editable__comment').text() || '';
          if ($(this).find('img').length) {
            type = 'picture';
          } else if ($(this).find('h2').length || $(this).find('h3').length) {
            type = 'text';
          }

          let data = {};

          if (type === 'picture') {
            data.imageId = $(this).find('img').attr('src').replace(/^.+\?/, '');
          } else if (type === 'text') {
            const heading = $(this).find('h2').text().trim() || '';
            const description = $(this).find('h3').text().trim() || '';

            heading && (data['heading'] = heading);
            description && (data['description'] = description);
          } else {
            data = null;
          }

          collection.push({ positionId, id, type, data, comment });
        });
        return collection;
      }
      // Create the payload object
      var payload = {
        boardId: board_id,
        gridId: grid_id,
        title: titleValue,
        description: descriptionValue,
        cells: buildCellsList(),
      };
      let jsonPayload = JSON.stringify(payload);

      const response = await sendRequest('public-styleboards/update', {
        method: 'PATCH',
        body: jsonPayload,
        authenticate: true,
      });

      if (response instanceof Error) {
        printError('#board__error', response);
        // e.target.classList.remove('spin');
        return;
      }
      if(document.getElementById('myboardfile').files[0] != undefined){
        const formData = new FormData();
        formData.append("logo",document.getElementById('myboardfile').files[0]);
        
        const response2 = await sendRequest(`public-styleboards/${board_id}/logo`, {
          method: 'POST',
          body: formData,
          authenticate: true,
        });
  
        if (response instanceof Error) {
          printError('#board__error', response);
          e.target.classList.remove('spin');
          return;
        }
      }
      
      e.target.classList.remove('spin');
      printError('#board__error', 'Board edited Successfully', 'success');
      getMyboards();
    };
  };
  
  //view styleboard
  const viewStyleboard = async (board_id, type) => {
    if (type === 'view') {
      hideContentForView();
    } else {
      showContentForEdit();
    }
    const loading = document.querySelector('#create_board_modal #loading');
    const publishStyleboard = document.querySelector('#publish_styleboard');
    loading.style.display = 'block';
    const response = await sendRequest(`public-styleboards/${board_id}/details`, {
      method: 'GET',
      authenticate: true,
    });
    if (response instanceof Error) {
      printError('#board__error', response);
      loading.style.display = 'none';
      return;
    }
    const gridId = response.gridId;
    let label = '';
    if (gridId == '6578413cb97117e2c84d80ca') {
      label = 'Grid 1';
    } else if (gridId == '65784157b97117e2c84d80cc') {
      label = 'Grid 2';
    } else if (gridId == '6578416db97117e2c84d80ce') {
      label = 'Grid 3';
    } else if (gridId == '660fd52cde8cb7a2b70077c2') {
      label = 'Grid 4';
    }

    // if (response.status === 'private') {
    //   publishStyleboard.setAttribute('data-type', 'publish');
    //   publishStyleboard.innerHTML = 'Publish';
    // } else {
    //   publishStyleboard.setAttribute('data-type', 'unpublish');
    //   publishStyleboard.innerHTML = 'Unpublish';
    // }

    updateTitleAndDescription(response.title, response.description);
    document.getElementById('myPreviewContainer').innerHTML = `<img src="${response.logoUrl}">`
    activeGridTemplate(label);
    updateCells(response.gridId , response.cells);
    loading.style.display = 'none';
    dragDropImgAndText();
  };

  //hide some elements for view
  const hideContentForView = () => {
    document
      .getElementById('titleInputStyleboard')
      .setAttribute('readonly', 'readonly');
    document
      .getElementById('descInputStyleboard')
      .setAttribute('readonly', 'readonly');
    document
      .getElementById('myboardfile')
      .setAttribute('disabled', 'true');
    document.getElementById('save_styleboard').style.display = 'none';
    document.querySelector('.styleboard_grid_box').style.display = 'none';
  };

  //show some element for edit {
  const showContentForEdit = () => {
    document.getElementById('titleInputStyleboard').removeAttribute('readonly');
    document.getElementById('descInputStyleboard').removeAttribute('readonly');
    document.getElementById('myboardfile').removeAttribute('disabled');
    document.getElementById('save_styleboard').style.display = 'flex';
    document.querySelector('.styleboard_grid_box').style.display = 'flex';
    document.getElementById('myboardfile').value='';
  };

  //update board title and description
  const updateTitleAndDescription = (title, desc) => {
    document.getElementById('breadcrumbBoardName').innerHTML = title;
    document.getElementById('titleInputStyleboard').value = title;
    document.getElementById('descInputStyleboard').value = desc;
  };

  //active grid tab
  const activeGridTemplate = (label) => {
    let tabGridlinks = document.querySelectorAll('.grid_tablink');
    let tabGridContent = document.querySelectorAll('.tab_grid_content');
    for (g of tabGridlinks) {
      const gridLabel = g.getAttribute('data-label');
      if (gridLabel === label) {
        g.classList.add('active_grid');
      } else {
        g.classList.remove('active_grid');
      }
    }
    for (g of tabGridContent) {
      const gridLabel = g.getAttribute('data-label');
      if (gridLabel === label) {
        g.classList.add('activeGridContent');
      } else {
        g.classList.remove('activeGridContent');
      }
    }
  };
  
  var grid_tablink = document.getElementById("grid_tablink");
  function hideAllGridElements() {
      var gridElements = document.querySelectorAll('.grid_tablink');
      gridElements.forEach(function(element) {
          element.style.display = 'none';
      });
  }
  // Public update cells
  const updateCells = (gridId , cells) => {
    if (gridId == '6578413cb97117e2c84d80ca') {
        hideAllGridElements(); 
        var grid1Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 1"]');
        grid1Elements.forEach(function(element) {
            element.style.display = 'block';
        });
    } else if (gridId == '65784157b97117e2c84d80cc') {
        hideAllGridElements();
        var grid2Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 2"]');
        grid2Elements.forEach(function(element) {
            element.style.display = 'block';
        });
    } else if (gridId == '6578416db97117e2c84d80ce') {
        hideAllGridElements();
        var grid3Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 3"]');
        grid3Elements.forEach(function(element) {
            element.style.display = 'block';
        });
    } else if (gridId == '660fd52cde8cb7a2b70077c2') {
        hideAllGridElements();
        var grid4Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 4"]');
        grid4Elements.forEach(function(element) {
            element.style.display = 'block';
        });
    }
    
      cells.forEach(function (cell) {
        const view_cell = document.querySelector(
          '.activeGridContent [data-id="' + cell.positionId + '"]'
        );
        view_cell.setAttribute('data-cell-id', cell.id);
        view_cell.innerHTML = `<div class="cursor-pointer sb-delete-img"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.9213 5.56358H17.9925V4.50828C17.9925 3.67655 17.3168 3 16.4846 3H7.43646C6.60426 3 5.92854 3.67655 5.92854 4.50828V5.56358H3V7.28357H4.20484L5.79381 20.1064C5.92772 21.1866 6.84863 22 7.93689 22H15.9842C17.0724 22 17.9934 21.1866 18.1273 20.1064L19.7162 7.2836H20.9213V5.56358ZM7.64853 5.56358V4.71999H16.2725V5.56358H7.64853ZM16.4205 19.8948C16.3932 20.114 16.2052 20.28 15.9841 20.28H7.93689C7.71576 20.28 7.52779 20.1139 7.50055 19.8946L5.93785 7.2836H17.9832L16.4205 19.8948Z" fill="black"></path></svg></div>`;
  
        if (cell.type == 'picture') {
          const imgUrl = cell.data.imageUrl + '?' + cell.data.imageId;
          view_cell.innerHTML =
            view_cell.innerHTML + '<img src="' + imgUrl + '">';
          view_cell.classList.add('el-dropped');
        }
        if (cell.type == 'text') {
          let heading = '';
          let text = '';
          if (cell.data.heading) {
            heading =
              '<h2 class="editable__text write__heading">' +
              cell.data.heading +
              '</h2>';
          }
          if (cell.data.description) {
            text =
              '<h3 class="editable__text write__desc">' +
              cell.data.description +
              '</h3>';
          }
          view_cell.innerHTML =
            view_cell.innerHTML + '<div>' + heading + text + '</div>';
          view_cell.classList.add('el-dropped');
        }
        if(cell?.comment && cell?.comment !== 'Add a comment') {
          view_cell.nextElementSibling.innerHTML =  cell.comment?.replace('Add a comment', '');
        } else {
          view_cell.nextElementSibling.innerHTML =  'Add a comment'
        }
      });
    };
  }

  //Stylist clients Page
  const stylistClients = (stylist_id) => {
    //stylist customers
    const getCustomers = async () => {
  
        const response = await sendRequest ('stylist/customers/get',{ 
          method: "GET",
          authenticate: true
        });
  
        const clientData = document.getElementById("client_data");
        //update on create session modaldropdown
        const client_dropdown_btn = document.getElementById("client_dropdown_btn");
        let client_drop;
        response.list?.forEach(function (ls) {
          clientData.innerHTML += `<a href="/pages/stylist-single-client?id=${ls.id}"<div class="client_profile">
                  <div class="client_profile_img">
                  <img class="gm_img" src="${ls.avatarUrl}" />
                  </div>
                  <h3>${ls.firstName} ${ls.lastName}</h3>
                </div></a>`;
          client_drop += `<option value="${ls.shopifyCustomerId}">${ls.firstName} ${ls.lastName}</option>`;
        });
  
        client_dropdown_btn.innerHTML ="<option value=''>Select Client</option>" + client_drop;
    };
  
    //stylist consultation
  //  const consultations = () => {
  //    const getConsultations = async () => { 
  //         const response = await sendRequest(`consultations/stylist/my-appointments`, {
  //                     method: "GET",
  //                     authenticate: true
  //                   }); 
  
  //         if (response instanceof Error) {
  //           alert('Error Getting Consultations')
  //           return;
  //         }
  
  //       const appointTable = document.getElementById("appoint_table");
  //       appointTable .innerHTML = '';
  //       let client_drop;
  //       response.nodes.forEach(function (ls) {
  //         appointTable.innerHTML += `<tr>
  //                       <td>
  //                         <div class="consultation_name">${ls.customer?.firstName} ${ls.customer?.lastName}</div>
  //                       </td>
  //                       <td>${ls.slotDate}</td>
  //                       <td>${ls.slotTime}</td>
  //                       <td>
  //                         <div class="consultation_status">
  //                           <span class="${ls.status=='approved'&&'status_confirm'} ${ls.status=='requested'&&'status_req'} ${ls.status=='denied'&&'status_denied'}"></span>${ls.status}
  //                         </div>
  //                       </td>
  //                       <td><button class="viewSlotsBtn" data-id="${ls.id}" data-name="${ls.customer?.firstName} ${ls.customer?.lastName}" data-date="${ls.slotDate}" data-time="${ls.slotTime}" data-status="${ls.status}">View</button></td>
  //                     </tr>`;
  //         updateConsultationStatus(document.querySelectorAll(".viewSlotsBtn"));
  //       });
  //   }
  
  //   const updateConsultationStatus = (element) => {
  //    for( el of element ) {
  //     el.addEventListener( 'click', function(e){
  //       const apt_modal = document.getElementById("apt_modal");
  //       apt_modal.style.display = 'block';
  //       const id = e.target.getAttribute('data-id');
  //       const name = e.target.getAttribute('data-name');
  //       const date = e.target.getAttribute('data-date');
  //       const time = e.target.getAttribute('data-time');
  //       const status = e.target.getAttribute('data-status');
  
  //       if( status.toLowerCase() === 'requested' ){
  //         document.querySelector('.rec_footer_modal').style.display = 'flex';
  //         document.querySelector('.meet__url').style.display = 'block';
  //       }else{
  //         document.querySelector('.rec_footer_modal').style.display = 'none';
  //         document.querySelector('.meet__url').style.display = 'none';
  //       }
  
  //       document.querySelector('.cons_client_name h3').innerHTML = name;
  //       document.querySelector('.cons_client_date h3').innerHTML = date + ' - ' + time;
  //       document.querySelector('.cons_client_status h3').innerHTML = status;
  //       approveRequest(id, apt_modal);
  //       denyRequest(id, apt_modal);
  //     });
  //    }
  //   } 
  
  //  const approveRequest = (id, apt_modal) => {
  //     const approve_req = document.getElementById("approve_req");
  //     approve_req.onclick = async (e) => {
  //       const meetUrl = document.getElementById("meet_link").value;
  //       let bodyData = {meetUrl}
  
  //       let body = JSON.stringify(bodyData);
        
  //      const response = await sendRequest(`consultations/stylist/accept-appointment/${id}`, {
  //       method: "PATCH",
  //       body: body,
  //       authenticate: true,
  //     });
  
  //      //loading submit button
  //       e.target.classList.add('spin'); 
  
  //     if (response instanceof Error) {
  //       printError('#apt__error', response);
  //        e.target.classList.remove('spin'); 
  //       return;
  //     }
  
  //       getConsultations();
  //       apt_modal.style.display = 'none';
  //       e.target.classList.remove('spin');
  //     }
  // }
     
  //  const denyRequest = (id, apt_modal) => {
  //     const deny_req = document.getElementById("deny_req");
  //     deny_req.onclick = async (e) => {
  //      const response = await sendRequest(`consultations/stylist/reject-appointment/${id}`, {
  //       method: "PATCH",
  //       authenticate: true,
  //     });
  
  //      //loading submit button
  //       e.target.classList.add('spin'); 
  
  //     if (response instanceof Error) {
  //       printError('#apt__error', response);
  //        e.target.classList.remove('spin'); 
  //       return;
  //     }
  
  //       getConsultations();
  //       apt_modal.style.display = 'none';
  //       e.target.classList.remove('spin');
  //     }
  // }   
        
  //    const getAvailability = async () => {
  //      const response = await sendRequest("consultations/stylist/get-availability", {
  //       method: "GET",
  //       authenticate: true,
  //     });
  
  //      const [,fromHour,fromPost] = response.from.match(/(\d+)(AM|PM)/i);
  //      const [,untilHour, untilPost] = response.until.match(/(\d+)(AM|PM)/i);
  
  //      $('.avail_from input').val(fromHour);
  //      $('.avail_from p').removeClass('active');
  //      $( '.avail_from p[data-value="'+fromPost+'"').addClass('active');
       
       
  //      $('.avail_until input').val(untilHour);
  //      $('.avail_until p').removeClass('active');
  //      $( '.avail_until p[data-value="'+untilPost+'"').addClass('active');
       
  //      response.days.forEach( (day) => {
  //        document.querySelector(`.avail_days p[data-value="${day}"]`).classList.add('active');
  //      })
      
  //     if (response instanceof Error) {
  //       // printError('#session-accordion', response);
  //       return;
  //     }
  //    }
     
  //    const availabilityBtn = document.getElementById("availabilityBtn");
  //   // availabilityBtn.onclick = async (e) => {
  //   //    printError('#availModalError', '');
  //   //   if( $('.avail_from input').val() == '' || $('.avail_until input').val() == '' ) {
  //   //     printError('#availModalError', 'Enter from and until time!');
  //   //     return;
  //   //   }
      
  //   //   const days = [];
  //   //   $('.avail_days p.active').each( function(){
  //   //     days.push($(this).attr('data-value'));
  //   //   });
  
  //   //   if( !days.length) {
  //   //     printError('#availModalError', 'Please Select Days!');
  //   //     return;
  //   //   }
  
  //   //   let bodyData = {
  //   //       from: $('.avail_from input').val() + $('.avail_from p.active').text().trim(),
  //   //       until: $('.avail_until input').val() + $('.avail_until p.active').text().trim(),
  //   //       days,
  //   //     }
  
  //   //   let body = JSON.stringify(bodyData);
  //   //    const response = await sendRequest("consultations/stylist/set-availability", {
  //   //     method: "POST",
  //   //     body: body,
  //   //     authenticate: true,
  //   //   });
  
  //   //   if (response instanceof Error) {
  //   //     printError('#availModalError', response);
  //   //     return;
  //   //   }
  
  //   //   $('#availModalSuccess').html('Availability Added Successfully.');
      
  //   // }
     
  //    getConsultations();
  //    getAvailability();
  //  } 
    
    //stylist sessions
    const getSessions = async () => {
      let sessionAccordion = document.getElementById("session-accordion");
  
      const response = await sendRequest("style-sessions/list", {
        method: "GET",
        authenticate: true,
      });
  
      if (response instanceof Error) {
        printError('#session-accordion', response);
        return;
      }
      
        sessionAccordion.innerHTML = "";
        const list = response.list;
      if( list.length > 0 ){
        list?.forEach(function (ls, index) {
          let name = '';
          let customerId = ls.customer?.id;
          if( !Object.keys(ls.customer).length ){
            name = 'PUBLIC STYLE SESSIONS';
          }else{
            name = ls.customer.firstName + " " + ls.customer.lastName;
          }
          sessionAccordion.innerHTML += `<div class="accordion-item" id="accordion-item-${index}">
              <div
                class="accordion-header"
                onclick="toggleAccordionItem(this)"
              >
                ${name} - ${ls.sessionTitle}
                <svg class="chevron-down" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3977 15.6629C12.178 15.8826 11.8219 15.8826 11.6022 15.6629L5.86739 9.92804C5.64772 9.70837 5.64772 9.35227 5.86739 9.13259L6.13256 8.86739C6.35222 8.64772 6.70838 8.64772 6.92805 8.86739L12 13.9393L17.0719 8.86739C17.2916 8.64772 17.6477 8.64772 17.8674 8.86739L18.1326 9.13259C18.3522 9.35227 18.3522 9.70837 18.1326 9.92804L12.3977 15.6629Z" fill="black"/>
                </svg>
                <svg class="chevron-up" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6023 8.33708C11.822 8.11741 12.1781 8.11741 12.3978 8.33708L18.1326 14.072C18.3523 14.2916 18.3523 14.6477 18.1326 14.8674L17.8674 15.1326C17.6478 15.3523 17.2916 15.3523 17.0719 15.1326L12 10.0607L6.92808 15.1326C6.7084 15.3523 6.3523 15.3523 6.13263 15.1326L5.86743 14.8674C5.64775 14.6477 5.64775 14.2916 5.86743 14.072L11.6023 8.33708Z" fill="black"/>
                </svg>
              </div>
              <div class="accordion-content">
                <button class="create_styleBtn" data-customer-id="${ls.customer.shopifyCustomerId}" data-session-id="${ls.sessionId}">Create Client Style Board</button>
                <div id="${ls.sessionId}" class="my_styleboard_grid">
              </div>
            </div>`;
           ls.boards.forEach( function(br, index2) {
             document.getElementById(ls.sessionId).innerHTML += `<div class="my_styleboard_profile">
                    <div class="my_styleboard_img">
                       ${br.imageUrl ? `<img class="gm_img" src="${br.imageUrl}" alt="board image" />` : `<img class="gm_img" src="https://cdn.shopify.com/s/files/1/0826/0318/0316/files/no-img.jpg?v=1716453799" alt="board image" />`}
                    </div>
                    <div class="my_styleboard_content">
                      <h2>${br.boardTitle.substring(0, 20)}</h2>
                      <div class="my_styleboard_review">
                        
                      </div>
                      <div class="btn_group">
                        <button data-id="${customerId}" data-board-id="${br.boardId}" class="view_styleboard">View</button>
                        <button data-board-id="${br.boardId}" class="edit_styleboard" data-customer-id="${ls.customer.shopifyCustomerId}" data-session-id="${ls.sessionId}">Edit</button>
                      </div>
                    </div>
                  </div>
                </div>`
           });
          
        });
        }
        openStyleboard(document.querySelectorAll(".create_styleBtn"), document.querySelectorAll(".view_styleboard"), document.querySelectorAll(".edit_styleboard"));   
    };

     function resetComments() {
         //console.log("testinggrid")
         const grid = $('div.tab_grid_content.activeGridContent');
         //console.log("testinggridgrid" , grid)
         //console.log("testinggridgridlen" , grid.length)
       
        grid.find('.grid_img').each(function () {
          //console.log("comment>>>>22" ,$(this).next('.editable__comment:first').text() )
          $(this).next('.editable__comment:first').text('');
          $(this).next('.editable__comment:first').text("Add a comment");
          //console.log("comment>>>>" ,$(this).next('.editable__comment:first').text() )
        });
      }
    
    function openStyleboard(element, viewElement, editElement) {
      const shopping_list = document.getElementById("shopping__list");
      for (const el of element) {
        el.addEventListener("click", function (e) {
          shopping_list.style.display = 'none';
          const style_modal = document.getElementById("create_board_modal");
          const customer_id = e.target.getAttribute("data-customer-id");
          const session_id = e.target.getAttribute("data-session-id");
           printError('#board__error', '');
  
          const gridImg = document.querySelectorAll('.grid_img');
          for( g of gridImg ){
            g.innerHTML = '';
            g.classList.remove('el-dropped');
          };
          showContentForCreate();
          style_modal.style.display = "block";
          style_modal.setAttribute('data-type', 'create');
          document.getElementById("titleInputStyleboard").focus();
          createStyleboard(customer_id, session_id);
          resetComments()
          const publishStyleboard = document.getElementById("publish_styleboard");
             publishStyleboard.setAttribute('data-type', 'publish');
            publishStyleboard.innerHTML = 'Publish';
          });
      }
      for (const el of viewElement) {
        el.addEventListener("click", function (e) {
          const style_modal = document.getElementById("create_board_modal");
          const board_id = e.target.getAttribute("data-board-id");
          const customer_id = e.target.getAttribute("data-id");
           printError('#board__error', '');
          shopping_list.style.display = 'block';
          style_modal.style.display = "block";
          viewStyleboard(board_id, 'view');
          publishUnpublishBoard(board_id);
          shoppingList(board_id);
          messaging(customer_id, board_id);
        });
      }
      for (const el of editElement) {
        el.addEventListener("click", function (e) {
          const style_modal = document.getElementById("create_board_modal");
          const customer_id = e.target.getAttribute("data-customer-id");
          const session_id = e.target.getAttribute("data-session-id");
          const board_id = e.target.getAttribute("data-board-id");
          
           printError('#board__error', '');
  
          shopping_list.style.display = 'block';
          style_modal.style.display = "block";
          style_modal.setAttribute('data-type', 'edit');
          viewStyleboard(board_id, 'edit');
          updateStyleboard(customer_id, session_id, board_id);
          publishUnpublishBoard(board_id);
          shoppingList(board_id);
        });
      }
      
    }
  
    //display messages
  const displayMessages = async (id, boardId) => {
          const chattingAreaBody = document.getElementById("chatting_area_body");
          chattingAreaBody.innerHTML = '<div class="loadMessages"><div id="loader"></div></div>';
            const response = await sendRequest(`board-messaging/stylist/${boardId}/conversation/${id}`,
              {
                method: "GET",
                authenticate: true,
              });
  
            if (response instanceof Error) {
              alert(response);
              return;
            }
          
  
          // Messages Display
          const messages = response?.messages;
          if (messages && messages.length !== 0){
  
            const customer = response.customer;
            let messageData = "";
            messages.forEach((msg) => {
            if (msg?.by_stylist) {
              let mediaImages = "";
              if (msg.media && msg.media.length > 0) {
                msg.media.forEach((image) => {
                    mediaImages += `<img src="${image}" alt="Image" />`;
                });
              }
              const stylistMessage = `
                      <div class="sent_message">
                          <div class="sent_message_box">
                              ${msg?.message}
                          ${mediaImages !== "" ? mediaImages : ""}
                          </div>
                          <div class="sent_message_time">${formatTimestamp(
                            msg?.created_at
                          )}</div>
                      </div>
                      `;
              messageData = stylistMessage + messageData;
            } else {
              let mediaImages = "";
              if (msg.media && msg.media.length > 0) {
              msg.media.forEach((image) => {
                  mediaImages += `<img src="${image}" alt="Image" />`;
              });
            }
  
              const customerMessage = `
                  <div class="client_message">
                      <div class="client_message_title">${customer.first_name} ${
                customer.last_name
              }</div>
                      <div class="client_message_box">
                      ${msg?.message}
                          ${mediaImages !== "" ? mediaImages : ""}
                      </div>
                      <div class="client_message_time">${formatTimestamp(
                        msg?.created_at
                      )}</div>
                  </div>
                  `;
               messageData = customerMessage + messageData;
            }
  
            chattingAreaBody.innerHTML = messageData;
          });
  
            //scroll to latest message
            chattingAreaBody.scrollTop = chattingAreaBody.scrollHeight;
            
            } else{
              chattingAreaBody.innerHTML = "";
            }
  }  
  
  // meassaging feature  
  const messaging = (id, boardId) => {
    displayMessages(id, boardId);
    const sendMessage = document.querySelector(".send_message");
   $(sendMessage).off('click').on('click', async function(e){
      let ele = e.currentTarget;
      ele.classList.add('spin');
          const messageInput = document.querySelector(
            ".chatting_area_input_text"
          );
          const mediaInput = document.querySelector(".chatting_area_input_media");
          const messageText = messageInput?.value;
  
          const formData = new FormData();
          formData.append("customer_id", id);
          formData.append("board_id", boardId);
          formData.append("message", messageText);
  
          if (mediaInput && mediaInput.files) {
            for (var i = 0; i < mediaInput.files.length; i++) {
              var file = mediaInput.files[i];
              formData.append("media", file);
            }
          }
  
       const response = await sendRequest("board-messaging/stylist/create",
              {
                method: "POST",
                body: formData,
                authenticate: true,
              });
  
            if (response instanceof Error) {
              alert(response);
              ele.classList.remove('spin');
              return;
            }
              messageInput.value = "";
              mediaInput.value = "";
              chatImagePreview.innerHTML = "";
              displayMessages(id, boardId);
              ele.classList.remove('spin');
    });
  }  
    window.handleDeepLink = async function(productLink) {
       if (!productLink || productLink === "Not provided") {
         alert('Deep link not provided');
         return;
       }
       const stylistId = document.querySelector(".page_profile_content").getAttribute("stylist-id");
       const parsedUrl = new URL(productLink);
       const mainWebsiteLink  = parsedUrl.origin;
      if (productLink == "Not provided") {
            alert('Deep link not provided');
            return
        } else {
           const response = await sendRequest(`links/generate?site=${mainWebsiteLink}&stylistID=${stylistId}&pageUrl=${productLink}`,
              {
                method: "GET",
                authenticate: true,
              }
            );
  
            if (response instanceof Error) {
              printError('#rec_message_error', response);
              e.classList.remove('spin');
              return;
             }
            if(response.msg){
               window.open(productLink)
              return
            }
            window.open(response)
        }
    };
    
    // Style Session Styleboard Recommendation
    // Display recommendation
       async function displayRecommendations(inspirationBoardId) {
          const shoppingProductList = document.querySelector(".shopping_product_list");
         const stylistId = document.querySelector(".page_profile_content").getAttribute("stylist-id");
         
          shoppingProductList.innerHTML = '';
          const response = await sendRequest(`styleboard-products/${inspirationBoardId}/${stylistId}/list`,
          {
            method: "GET",
            authenticate: true
          });
  
          if (response instanceof Error) {
              return;
          }
           
         const titleKeys = Object.keys(response)
          titleKeys.forEach((title)=> {
               const cards = response[title]
              const categoryDiv = document.createElement("div"); 
              categoryDiv.classList.add("category-div");
               categoryDiv.innerHTML = `<div class="category-title"><h1>${title}</h1></div>`;
               const categoryCardsDiv = document.createElement("div"); 
              categoryCardsDiv.classList.add("category-cards-div");
              categoryCardsDiv.setAttribute("data-category-id", cards[0]?.categoryId || "-")
          const editType = document.getElementById("create_board_modal").getAttribute('data-type');
               cards?.forEach((recommendation) => {
                      categoryCardsDiv.innerHTML = categoryCardsDiv.innerHTML + `
                        <div class="rec_product_card" data-product-id="${recommendation?.id}">
                          <div class="rec_product_img"><img src="${recommendation?.coverUrl}" /></div>
                          <div class="rec_product_content">
                            <h3 class="rec_product">${recommendation.title}</h3>
                            <h4 class="rec_product_rate">$${recommendation.price}</h4>
                            <button class="rec_close_button delete_recProduct" data-board-id=${inspirationBoardId} data-id="${recommendation.id}"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                <path d="M13.866 13.3946L13.3945 13.866C13.1342 14.1263 12.7121 14.1263 12.4517 13.866L7.03064 8.44484L1.60944 13.8659C1.34914 14.1263 0.927022 14.1263 0.666672 13.8659L0.195262 13.3945C-0.0650875 13.1342 -0.0650875 12.7121 0.195262 12.4517L5.61644 7.03064L0.195262 1.60944C-0.0650875 1.34914 -0.0650875 0.927022 0.195262 0.666672L0.666662 0.195272C0.927012 -0.065078 1.34914 -0.065078 1.60944 0.195272L7.03064 5.61644L12.4517 0.195262C12.7121 -0.0650875 13.1342 -0.0650875 13.3945 0.195262L13.866 0.666662C14.1263 0.927012 14.1263 1.34914 13.866 1.60944L8.44484 7.03064L13.866 12.4517C14.1263 12.7121 14.1263 13.1342 13.866 13.3946Z" fill="black"/>
                                </svg>
                            </button>
                            <div class="rec_button_main">
                            <button class="rec_product_link" id="deepLinkCheck" onclick="handleDeepLink('${recommendation.pageUrl}')">Shop now <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.96028 6.64234C7.17996 6.86202 7.17996 7.21812 6.96028 7.43779L1.22541 13.1727C1.00573 13.3923 0.649631 13.3923 0.429956 13.1727L0.164756 12.9075C-0.0549187 12.6878 -0.0549187 12.3317 0.164756 12.112L5.23671 7.04007L0.164756 1.96812C-0.0549186 1.74844 -0.0549186 1.39234 0.164756 1.17267L0.429956 0.907467C0.649631 0.687792 1.00573 0.687792 1.22541 0.907467L6.96028 6.64234Z" fill="black"/>
                            </svg>
                            </button>
                            <button class="rec_update_button update_recProduct" data-board-id=${inspirationBoardId} data-id="${recommendation.id}" data-title="${recommendation.title}" data-cover="${recommendation?.coverUrl}" data-page="${recommendation.pageUrl}" data-price="${recommendation.price}" data-brand="${recommendation.brandName}" data-category="${title}">Update</button>
                            </div>
                          </div>
                        </div>
                  ` 
                 categoryDiv.append(categoryCardsDiv)
          if (editType == 'edit') {
                 // Drag and Drop 
                  const dropItems = categoryDiv.querySelector('.category-cards-div');
                  new Sortable(dropItems, {
                      animation: 350,
                      chosenClass: "sortable-chosen",
                      dragClass: "sortable-drag",
                      store: {
                        // We keep the order of the list
                        set: (sortable) =>{
                            const order = sortable.toArray()
                            localStorage.setItem(sortable.options.group.name, order.join('|'))
                            handleSorting(sortable);
                        },
                  
                        // We get the order of the list
                        get: (sortable) =>{
                            const order = localStorage.getItem(sortable.options.group.name)
                            return order ? order.split('|') : []
                        }
                      }
                  });
          }
               });
            shoppingProductList.append(categoryDiv);
          })
      }
      
      async function sortProducts(categoryId, productIds) {
         const response = await sendRequest(`styleboard-products/sort`,
          {
            method: "POST",
            authenticate: true,
            body: JSON.stringify({
                    categoryId: categoryId,
                    products: productIds
                })
          });
           if (response instanceof Error) {
              return;
           }
        }
  
      function handleSorting(sortable) {
            const order = sortable.toArray();
            const categoryId = sortable.el.getAttribute('data-category-id');
            const productIds = Array.from(sortable.el.querySelectorAll('.rec_product_card')).map(card => card.getAttribute('data-product-id'));
            sortProducts(categoryId, productIds);
        }
  
    // const addRecommendation = async (e, close) => {
    //   printError('#rec_message_error', '');
    //   const modalErrorMessage = document.getElementById("rec_message_error");
    //   const title = document.getElementById("titleInput")?.value;
    //   const pageUrl = document.getElementById("productUrlInput")?.value;
    //   const coverUrl = document.getElementById("imageUrlInput")?.value;
    //   const price = document.getElementById("priceInput")?.value;
    //   const brandName = document.getElementById("brandInput")?.value;
  
    //   modalErrorMessage.innerHTML = "";
  
    //   if (!title || !pageUrl || !coverUrl || !price || !brandName) {
    //     modalErrorMessage.innerHTML = "All fields are required";
    //     return;
    //   }
  
    //   e.target.classList.add('spin');
    //   const inspirationBoardId = $('#board__id').val() || '';
    //   const bodyData = { inspirationBoardId, title, pageUrl, coverUrl, price, brandName };
    //   let bodyPayload = JSON.stringify(bodyData);
    //     const response = await sendRequest("styleboard-products/add",
    //       {
    //         method: "POST",
    //         body: bodyPayload,
    //         authenticate: true,
    //       }
    //     );
  
    //   if (response instanceof Error) {
    //     printError('#rec_message_error', response);
    //     e.target.classList.remove('spin');
    //     return;
    //    }
  
    //    displayRecommendations( $('#board__id').val() );
  
    //     printError('#rec_message_error', 'Recommendation created successfully', 'success');
    //     e.target.classList.remove('spin');
    //     document.getElementById("titleInput").value = "";
    //     document.getElementById("productUrlInput").value = "";
    //     document.getElementById("imageUrlInput").value = "";
    //     document.getElementById("priceInput").value = "";
    //     document.getElementById("brandInput").value = "";
    //     if( close ){
    //       rec_product_modal.style.display = 'none';
    //     }
    //     setTimeout( function(){
    //       printError('#rec_message_error', '', );
    //     },2000);
    // } 
  
     const addRecommendation = async (e, close) => {
      printError('#rec_message_error', '');
      const modalErrorMessage = document.getElementById("rec_message_error");
      const title = document.getElementById("titleInput")?.value;
      const pageUrl = document.getElementById("productUrlInput")?.value;
      const coverUrl = document.getElementById("imageUrlInput")?.value;
      const price = document.getElementById("priceInput")?.value;
      const brandName = document.getElementById("brandInput")?.value;
      const categoryName = document.getElementById("categoryInput")?.value;
  
      modalErrorMessage.innerHTML = "";
  
      if (!title || !pageUrl || !coverUrl || !price || !brandName) {
        modalErrorMessage.innerHTML = "All fields are required";
        return;
      }
  
      e.target.classList.add('spin');
      const inspirationBoardId = $('#board__id').val() || '';
      const bodyData = { inspirationBoardId, title, pageUrl, coverUrl, price, brandName, categoryName };
      let bodyPayload = JSON.stringify(bodyData);
        const response = await sendRequest("styleboard-products/add",
          {
            method: "POST",
            body: bodyPayload,
            authenticate: true,
          }
        );
  
      if (response instanceof Error) {
        printError('#rec_message_error', response);
        e.target.classList.remove('spin');
        return;
       }
  
       displayRecommendations( $('#board__id').val() );
  
        printError('#rec_message_error', 'Recommendation created successfully', 'success');
        e.target.classList.remove('spin');
        document.getElementById("titleInput").value = "";
        document.getElementById("productUrlInput").value = "";
        document.getElementById("imageUrlInput").value = "";
        document.getElementById("priceInput").value = "";
        document.getElementById("brandInput").value = "";
        document.getElementById("categoryInput").value = "";
        if( close ){
          rec_product_modal.style.display = 'none';
        }
        setTimeout( function(){
          printError('#rec_message_error', '', );
        },2000);
    } 
    const saveProduct = document.getElementById("save__product");
    const save__moreProduct = document.getElementById("save__moreProduct");
    
      saveProduct?.addEventListener("click", function (e) {
        addRecommendation(e, true);
      });
      save__moreProduct?.addEventListener("click", function (e) {
        addRecommendation(e, false);
      });
    
    //shopping list 
    const shoppingList = (inspirationBoardId) => {
      const board__id = document.getElementById("board__id");
      board__id.value = inspirationBoardId;
      const board_addProduct = document.getElementById("board_addProduct");
      const rec_product_modal = document.getElementById("rec_product_modal");
      
      board_addProduct.onclick = () => {
        rec_product_modal.style.display = 'flex';
        const shoppingProductList = document.querySelector(".shopping_product_list");
        // shoppingProductList.innerHTML = '';
      }
      
       displayRecommendations(inspirationBoardId);
      
    }
    
  $(document).on( 'click', '.update_recProduct', async function(){
    $('#updateModal').css('display', 'flex');
    printError('#update_message_error', '');
    const id = $(this).attr('data-id');
    const inspirationBoardId = $(this).attr('data-board-id');
    const title = $(this).attr('data-title');
    const coverUrl = $(this).attr('data-cover');
    const pageUrl = $(this).attr('data-page');
    const price = $(this).attr('data-price');
    const brandName = $(this).attr('data-brand');
    const categoryName = $(this).attr('data-category');
  
    $('#BoardIdInputUpdate').val(inspirationBoardId);
    $('#IdInputUpdate').val(id);
    $('#productUrlInputUpdate').val(pageUrl);
    $('#imageUrlInputUpdate').val(coverUrl);
    $('#titleInputUpdate').val(title);
    $('#priceInputUpdate').val(price);
    $('#brandInputUpdate').val(brandName);
    $('#categoryInputUpdate').val(categoryName);
  });
  
   $(document).on( 'click', '.close_update_product', function(){
     $('#updateModal').hide();
   });    
  
  $(document).on( 'click', '.confirm_update', async function(){
    printError('#update_message_error', '');
    const id = $('#IdInputUpdate').val();
    const inspirationBoardId = $('#BoardIdInputUpdate').val();
    let bodyData = {
      id: id,
      inspirationBoardId: inspirationBoardId,
      title: $('#titleInputUpdate').val(),
      pageUrl: $('#productUrlInputUpdate').val(),
      coverUrl: $('#imageUrlInputUpdate').val(),
      price: $('#priceInputUpdate').val(),
      brandName: $('#brandInputUpdate').val(),
      categoryName: $('#categoryInputUpdate').val(),
    }
    let body = JSON.stringify(bodyData);
   const response = await sendRequest(`styleboard-products/update`,
        {
          method: "POST",
          body,
          authenticate: true
        });
  
     if (response instanceof Error) {
      printError('#update_message_error', response);
      return;
     }
       displayRecommendations(inspirationBoardId);
      printError('#update_message_error', 'Recommendation updated successfully.', 'success');
    
  });
  
    let recProductId = '';
    $(document).on( 'click', '.delete_recProduct', function(){
       document.getElementById("confirmModal").style.display = "flex";
       recProductId = $(this).attr('data-id');
     });
      
   $(document).on( 'click', '.close_confirm_modal', function(){
     $('#confirmModal').hide();
   });
       
   $(document).on( 'click', '.confirm_del', async function(){
      const response = await sendRequest(`styleboard-products/${recProductId}/remove`,
      {
        method: "DELETE",
        authenticate: true
      });
  
     if (response instanceof Error) {
      printError('#rec_productError', response);
      return;
     }
     
         displayRecommendations( $('#board__id').val() );
         document.getElementById("confirmModal").style.display = "none";
    });
    
  
    //publish unpublish styleboard
      const publishUnpublishBoard = (board_id) => {
        const publishStyleboard = document.getElementById("publish_styleboard");
        publishStyleboard.addEventListener("click", async function (e) {
          const type = e.target.getAttribute('data-type');
          printError('#board__error', '');
          
          //loading submit button
          e.target.classList.add('spin');
  
          // Create the payload object
        var payload = { boardId: board_id, };
  
        let jsonPayload = JSON.stringify(payload);
  
          const response = await sendRequest(`my-styleboards/${board_id}/${type}`, {
            method: "PATCH",
            body: jsonPayload,
            authenticate: true,
          });
  
         if( response instanceof Error) {
           printError('#board__error', response);
            e.target.classList.remove('spin');
            return;
          }
  
          e.target.classList.remove('spin');
          if( type == 'publish') {
            e.target.setAttribute('data-type', 'unpublish');
            e.target.innerHTML = 'Unpublish';
            printError('#board__error', 'Board publish successfully', 'success');
          }else {
            e.target.setAttribute('data-type', 'publish');
            e.target.innerHTML = 'Publish';
            printError('#board__error', 'Board unpublish successfully', 'success');
          }
          // getSessions();
          
        });
      }  
  
      function hideAllGridElements() {
      var gridElements = document.querySelectorAll('.grid_tablink');
      gridElements.forEach(function(element) {
          element.style.display = 'none';
      });
  }
    
    //view styleboard
    const viewStyleboard = async (board_id, type) => {
        const loading = document.querySelector('#create_board_modal #loading'); 
        const publishStyleboard = document.querySelector('#publish_styleboard'); 
        loading.style.display = 'block';
        const response = await sendRequest(`my-styleboards/${board_id}/details`, {
          method: "GET",
          authenticate: true,
        });
        if( response instanceof Error) {
          printError('#board__error', response);
         loading.style.display = 'none';
          return;
        }
        const gridId = response.gridId;
        let label = '';
        if(gridId == '6578413cb97117e2c84d80ca'){
          label = 'Grid 1';
        }else if( gridId == '65784157b97117e2c84d80cc' ){
          label = 'Grid 2';
        }else if( gridId == '6578416db97117e2c84d80ce' ){
          label = 'Grid 3';
      }  else if (gridId == '660fd52cde8cb7a2b70077c2') {
        label = 'Grid 4';
      }
  
       if( type === 'view'){
         hideContentForView();
       } else {
         showContentForEdit();
       }
  
       if( response.status === 'private') {
         publishStyleboard.setAttribute('data-type', 'publish');
         publishStyleboard.innerHTML = 'Publish';
       }else{
          publishStyleboard.setAttribute('data-type', 'unpublish');
          publishStyleboard.innerHTML = 'Unpublish';
       }
        
        updateTitleAndDescription(response.title, response.description);
        activeGridTemplate(label);
      
      if (gridId == '6578413cb97117e2c84d80ca') {
        hideAllGridElements(); 
        var grid1Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 1"]');
        grid1Elements.forEach(function(element) {
            element.style.display = 'block';
        });
        } else if (gridId == '65784157b97117e2c84d80cc') {
            hideAllGridElements();
            var grid2Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 2"]');
            grid2Elements.forEach(function(element) {
                element.style.display = 'block';
            });
        } else if (gridId == '6578416db97117e2c84d80ce') {
            hideAllGridElements();
            var grid3Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 3"]');
            grid3Elements.forEach(function(element) {
                element.style.display = 'block';
            });
        } else if (gridId == '660fd52cde8cb7a2b70077c2') {
            hideAllGridElements();
            var grid4Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 4"]');
            grid4Elements.forEach(function(element) {
                element.style.display = 'block';
            });
        }
  
      
        updateCells(response.gridId, response.cells);
        loading.style.display = 'none';
    }
  
  
  
    //hide some elements for view 
    const hideContentForView = () => {
      document.getElementById('titleInputStyleboard').setAttribute('readonly','readonly');
      document.getElementById('descInputStyleboard').setAttribute('readonly','readonly');
      document.getElementById("save_styleboard").style.display = 'none';
      document.querySelector('.styleboard_grid_box').style.display = 'none';
      document.querySelector('.chatting_area').style.display = 'block';
    }
  
    //show some element for edit {
    const showContentForEdit = () => {
      document.getElementById('titleInputStyleboard').removeAttribute('readonly');
      document.getElementById('descInputStyleboard').removeAttribute('readonly');
      document.getElementById("save_styleboard").style.display = 'flex';
      document.querySelector('.styleboard_grid_box').style.display = 'flex';
      document.querySelector('.chatting_area').style.display = 'none';
    }
  
    //show some element for create {
    const showContentForCreate = () => {
      document.getElementById('titleInputStyleboard').removeAttribute('readonly');
      document.getElementById('titleInputStyleboard').value = '';
      document.getElementById('descInputStyleboard').removeAttribute('readonly');
      document.getElementById('descInputStyleboard').value = '';
      document.getElementById("save_styleboard").style.display = 'flex';
      document.querySelector('.styleboard_grid_box').style.display = 'flex';
      document.querySelector('.chatting_area').style.display = 'none';
    }
    
    //update board title and description
    const updateTitleAndDescription = (title, desc) => {
      document.getElementById('breadcrumbBoardName').innerHTML = title;
      document.getElementById('titleInputStyleboard').value = title;
      document.getElementById('descInputStyleboard').value = desc;
    }
  
    //active grid tab
    const activeGridTemplate = (label) => {
      let tabGridlinks = document.querySelectorAll(".grid_tablink");
      let tabGridContent = document.querySelectorAll(".tab_grid_content");
        for( g of tabGridlinks){
          const gridLabel = g.getAttribute('data-label');
          if( gridLabel === label ) {
            g.classList.add('active_grid');
          }else {
             g.classList.remove('active_grid');
          }
        }
       for( g of tabGridContent){
          const gridLabel = g.getAttribute('data-label');
          if( gridLabel === label ) {
            g.classList.add('activeGridContent');
          }else {
             g.classList.remove('activeGridContent');
          }
        }
    }
  
  var grid_tablink = document.getElementById("grid_tablink");
  
  function hideAllGridElements() {
      var gridElements = document.querySelectorAll('.grid_tablink');
      gridElements.forEach(function(element) {
          element.style.display = 'none';
      });
  }
    // Private update cells
  const updateCells = (gridId , cells) => {
    if (gridId == '6578413cb97117e2c84d80ca') {
        hideAllGridElements(); 
        var grid1Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 1"]');
        grid1Elements.forEach(function(element) {
            element.style.display = 'block';
        });
    } else if (gridId == '65784157b97117e2c84d80cc') {
        hideAllGridElements();
        var grid2Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 2"]');
        grid2Elements.forEach(function(element) {
            element.style.display = 'block';
        });
    } else if (gridId == '6578416db97117e2c84d80ce') {
        hideAllGridElements();
        var grid3Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 3"]');
        grid3Elements.forEach(function(element) {
            element.style.display = 'block';
        });
    } else if (gridId == '660fd52cde8cb7a2b70077c2') {
        hideAllGridElements();
        var grid4Elements = document.querySelectorAll('.grid_tablink[data-label="Grid 4"]');
        grid4Elements.forEach(function(element) {
            element.style.display = 'block';
        });
    }
    
      cells.forEach(function(cell){
       const view_cell = document.querySelector('.activeGridContent [data-id="'+cell.positionId+'"]');
        view_cell.setAttribute('data-cell-id', cell.id);
       view_cell.innerHTML = (`<div class="cursor-pointer sb-delete-img"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.9213 5.56358H17.9925V4.50828C17.9925 3.67655 17.3168 3 16.4846 3H7.43646C6.60426 3 5.92854 3.67655 5.92854 4.50828V5.56358H3V7.28357H4.20484L5.79381 20.1064C5.92772 21.1866 6.84863 22 7.93689 22H15.9842C17.0724 22 17.9934 21.1866 18.1273 20.1064L19.7162 7.2836H20.9213V5.56358ZM7.64853 5.56358V4.71999H16.2725V5.56358H7.64853ZM16.4205 19.8948C16.3932 20.114 16.2052 20.28 15.9841 20.28H7.93689C7.71576 20.28 7.52779 20.1139 7.50055 19.8946L5.93785 7.2836H17.9832L16.4205 19.8948Z" fill="black"></path></svg></div>`);
  
       if(cell.type == 'picture'){
          const imgUrl = cell.data.imageUrl + '?' + cell.data.imageId;
          view_cell.innerHTML = view_cell.innerHTML + '<img src="'+imgUrl+'">';
          view_cell.classList.add('el-dropped');
        }
        if(cell.type == 'text'){
          let heading = '';
          let text = '';
          if(cell.data.heading){
            heading = '<h2 class="editable__text write__heading">'+cell.data.heading+'</h2>';
          }
          if(cell.data.description){
            text = '<h3 class="editable__text write__desc">'+cell.data.description+'</h3>';
          }
          view_cell.innerHTML = view_cell.innerHTML + '<div>'+heading+text+'</div>';
          view_cell.classList.add('el-dropped');
        }
         if(cell?.comment && cell?.comment !== 'Add a comment') {
          view_cell.nextElementSibling.innerHTML =  cell.comment?.replace('Add a comment', '');
        } else {
          view_cell.nextElementSibling.innerHTML =  'Add a comment'
        }      
      });
    }
  
    //update styleboard
    const updateStyleboard = (customer_id, session_id, board_id) => {
      const save_styleboard = document.getElementById("save_styleboard");
      save_styleboard.onclick = async (e) => {
        const titleValue = document.getElementById("titleInputStyleboard").value.trim();
        const descriptionValue = document.getElementById("descInputStyleboard").value.trim();
        const gridTablink = document.querySelectorAll(".grid_tablink");
  
        if( titleValue === '' ){
          printError('#board__error', 'Board title is required');
          return;
        }
  
        //loading submit button
         e.target.classList.add('spin');
  
        let grid_id;
        let grid_label = "";
        for (grid of gridTablink) {
          if (grid.classList.contains("active_grid")) {
            grid_label = grid.getAttribute("data-label");
          }
        }
        if (grid_label.trim() == "Grid 1") {
          grid_id = "6578413cb97117e2c84d80ca";
        }
        if (grid_label.trim() == "Grid 2") {
          grid_id = "65784157b97117e2c84d80cc";
        }
        if (grid_label.trim() == "Grid 3") {
          grid_id = "6578416db97117e2c84d80ce";
        } 
         if (grid_label.trim() == "Grid 4") {
          grid_id = "660fd52cde8cb7a2b70077c2";
        } 
  
  function buildCellsList () {
      const grid = $('div.tab_grid_content.activeGridContent');
  
      if ( !grid.length ) {
          return [];
      }
  
      const collection = [];
      
      grid.find('.grid_img').each(function() {
          const id = $(this).data('cell-id');
          const positionId = $(this).data('id');
          let type = 'none';
          const comment =  $(this).next('.editable__comment:first').text() || '';
  
          if( $(this).find('img').length ){
            type = 'picture';
          }else if( $(this).find('h2').length ||  $(this).find('h3').length ) {
            type = 'text';
          }
        
          let data = {};
  
          if (type === 'picture') {
              data.imageId = $(this).find('img').attr('src').replace(/^.+\?/, '')
          } else if (type === 'text') {
              const heading = $(this).find('h2').text().trim() || '';
              const description = $(this).find('h3').text().trim() || '';
  
              heading && (data['heading'] = heading);
              description && (data['description'] = description);
          }else{
            data = null;
          }
          collection.push({positionId, id, type, data, comment});
      });
  
      return collection;
  }
        // Create the payload object
        var payload = {
          boardId: board_id,
          gridId: grid_id,
          styleSessionId: session_id,
          title: titleValue,
          description: descriptionValue,
          cells: buildCellsList(),
        };
  
        let jsonPayload = JSON.stringify(payload);
  
          const response = await sendRequest("my-styleboards/update", {
            method: "PATCH",
            body: jsonPayload,
            authenticate: true,
          });
  
         if( response instanceof Error) {
           printError('#board__error', response);
            e.target.classList.remove('spin');
            return;
          }
  
          e.target.classList.remove('spin');
          printError('#board__error', 'Board edited Successfully', 'success');
          getSessions();
         
      };
    };
    
  //create client styleboard
  const createStyleboard = (customer_id, session_id) => {
    const save_styleboard = document.getElementById("save_styleboard");
    save_styleboard.onclick = async (e) => {
      // Disable the button to prevent multiple clicks
      save_styleboard.disabled = true;
  
      const titleValue = document.getElementById("titleInputStyleboard").value.trim();
      const descriptionValue = document.getElementById("descInputStyleboard").value.trim();
      const gridTablink = document.querySelectorAll(".grid_tablink");
  
      if (titleValue === '') {
        printError('#board__error', 'Board title is required');
        // Re-enable the button if there's an error
        save_styleboard.disabled = false;
        return;
      }
  
      // loading submit button
      e.target.classList.add('spin');
  
      let grid_id;
      let grid_label = "";
      for (grid of gridTablink) {
        if (grid.classList.contains("active_grid")) {
          grid_label = grid.getAttribute("data-label");
        }
      }
  
      if (grid_label.trim() == "Grid 1") {
        grid_id = "6578413cb97117e2c84d80ca";
      }
      if (grid_label.trim() == "Grid 2") {
        grid_id = "65784157b97117e2c84d80cc";
      }
      if (grid_label.trim() == "Grid 3") {
        grid_id = "6578416db97117e2c84d80ce";
      }
      if (grid_label.trim() == "Grid 4") {
        grid_id = "660fd52cde8cb7a2b70077c2";
      }
  
      function buildCellsList() {
        const grid = $('div.tab_grid_content.activeGridContent');
  
        if (!grid.length) {
          return [];
        }
  
        const collection = [];
  
        grid.find('.el-dropped').each(function () {
          const positionId = $(this).data('id');
          const type = $(this).find('img').length ? 'picture' : 'text';
          const commentNode = $(this).next('.editable__comment:first');
          const comment = commentNode.text() || '';
  
          const data = {};
  
          if (type === 'picture') {
            data.imageId = $(this).find('img').attr('src').replace(/^.+\?/, '')
          } else if (type === 'text') {
            const heading = $(this).find('h2').text().trim() || '';
            const description = $(this).find('h3').text().trim() || '';
  
            heading && (data['heading'] = heading);
            description && (data['description'] = description);
          }
  
          collection.push({ positionId, type, data, comment });
        });
  
        return collection;
      }
  
      // Create the payload object
      var payload = {
        gridId: grid_id,
        styleSessionId: session_id,
        title: titleValue,
        description: descriptionValue,
        cells: buildCellsList(),
      };
  
      let jsonPayload = JSON.stringify(payload);
  
      try {
        const response = await sendRequest("my-styleboards/create", {
          method: "POST",
          body: jsonPayload,
          authenticate: true,
        });
  
        if (response instanceof Error) {
          printError('#board__error', response);
        } else {
          setBoardIdForPublish(response.boardId);
          printError('#board__error', 'Board created Successfully', 'success');
          getSessions();
  
          // Reset the form fields after successful save
          document.getElementById("titleInputStyleboard").value = '';
          document.getElementById("descInputStyleboard").value = '';
          const grid = $('div.tab_grid_content.activeGridContent');
            grid.find('.el-dropped img').remove();
            grid.find('.el-dropped').removeClass('el-dropped');
            grid.find('.sb-delete-img').remove();
    
            grid.find('.editable__comment').text('Add a comment');
            grid.find('h2.editable__text').text('');
            grid.find('h3.editable__text').text('');
        }
      } catch (error) {
        printError('#board__error', error);
      } finally {
        // Re-enable the button and remove the spinner
        e.target.classList.remove('spin');
        save_styleboard.disabled = false;
      }
    };
  };
  
    const setBoardIdForPublish = (boardId) => {
      var elements = document.querySelectorAll('.rec_link_modal');
    
      elements.forEach(function(element) {
        if (element.getAttribute('data-type') === 'create') {
          element.setAttribute('data-board-id', boardId);
        }
      });
    }
  
    var publish_button = document.getElementById("publish_styleboard");
     $(publish_button).off('click').on("click", function() {
    var recLinkModal = document.querySelectorAll('.rec_link_modal');
    
      recLinkModal.forEach(function(recLinkModals) {
        if (recLinkModals.getAttribute('data-type') === 'create') {
          const recBoardId = recLinkModals.getAttribute('data-board-id');
          publishUnpublishBoard(recBoardId)
        }
      });
    });
  
    // create session
    const formSessionSubmit = document.getElementById("form-session-submit");
    formSessionSubmit.onclick = async (e) => {
      printError('#sessionFormError', "");
      const clientDropdownBtn = document.getElementById("client_dropdown_btn");
      const formSessionTitle = document.getElementById("form-session-title");
      const formSessionDesc = document.getElementById("form-session-desc");
      const formSessionClient = document.getElementById("client_dropdown_btn");
  
      if( formSessionTitle.value.trim() === '' || formSessionDesc.value.trim()=== '' || formSessionClient.value === '' ){
        printError('#sessionFormError', 'Fill all the fields!');
        return;
      }
      const bodyData = {
        customerId: formSessionClient.value,
        title: formSessionTitle.value,
        description: formSessionDesc.value,
      };
  
      const body = JSON.stringify(bodyData);
  
      //loading submit button
      e.target.classList.add('spin');
  
      const response = await sendRequest("style-sessions/create", {
        method: "POST",
        body: body,
        authenticate: true,
      });
  
      if( response instanceof Error) {
        printError('#sessionFormError', response);
         e.target.classList.remove('spin');
        return;
      }
  
      document.getElementById("client_dropdown_btn").value =  "";
      document.getElementById("form-session-title").value =  "";
      document.getElementById("form-session-desc").value =  "";
       document.getElementById("client_dropdown_btn").value =  "";
      
      e.target.classList.remove('spin');
       document.getElementById("create_session_modal").style.display = 'none';
      getSessions();
      
    };
  
  
    getCustomers();
    // consultations();
    getSessions();
  };

  //stylists add services
  const stylistAddServices = async (styleProfileBtn, id, services) => {
    styleProfileBtn.classList.add('spin');
    let bodyData = {
      services: services,
    };
    let body = JSON.stringify(bodyData);
  
      const response = await sendRequest ("stylist/add-services", {
        method: "PUT",
        body: body,
        authenticate: true
      });
  
    if( response instanceof Error) {
        printError('#service-error', response);
        styleProfileBtn.classList.remove('spin');
        return;
      }
    
        setTimeout(function () {
          styleProfileBtn.classList.remove('spin');
          window.location.reload();
        }, 5000);
     
  
  };

  //stylist set services
  const setServices = async (id, productHandle) => {
    const serviceError = document.getElementById("service-error");
    const response = await sendRequest("services/get-all", {
      method: "GET",
      authenticate: true,
    });
    let servicesArray = response.nodes;
  
    // const res = await fetch(
    //   window.shopUrl + "/products/" + productHandle + ".json",
    //   { method: "GET" }
    // );
    // const resData = await res.json();
  
    const userResponse = await sendRequest(`/me`, {
      method: "GET",
      authenticate: true,
    });
    const product_id = userResponse?.meta?.shopifyProductId;
    const VariantResponse = await sendRequest(`stylist/${product_id}/variants`, {
      method: "GET",
      authenticate: true,
    });
  
    for (variant of VariantResponse) {
    
    const matchService = servicesArray.find(function (item) {
        return item.name.trim() === variant.title.trim();
      });
  
      if( typeof matchService !== 'undefined') {
        document.getElementById(
          "add_service_sect"
        ).innerHTML += `<div id="main-${matchService.id}" data-policy="${variant.inventory_policy}" class="section_main ${variant.inventory_policy}"><div id="msg-${matchService.id}"></div><div class="service_added"><span>${variant.title}</span> 
                       <div class="price__main">
                       <input type="text" id="input-${matchService.id}" class="service_added_rate" value="${variant.price}" />
                       <button class="update_service" data-id=${matchService.id}><i class="fa fa-circle-o-notch fa-spin spinner"></i>Update</button>
                       <button class="disable_service" data-id=${matchService.id}><i class="fa fa-circle-o-notch fa-spin spinner"></i><span class="disable">Disable</span><span class="enable">Enable</span></button>
                       </div>
                          </div>
                       `;
      }
      servicesArray = servicesArray.filter(function (item) {
        return item.name.trim() != variant.title.trim();
      });
    }
  
    let options = "";
    for (option of servicesArray) {
      if( option.status === 10){
        options += `<div class="enable-service"><div class="service-check"><input type="checkbox" data-price="20" value="${option.id}"><span class="service-name">${option.name}</span></div>
        <div class="service-price"><input type="number" min="0" placeholder="Add Rate" /></div></div>`;
      }
    }
    if(options == ""){
      document.querySelector('.service-main').style.display = 'none';
      document.querySelector('.style_profile_btn').style.display = 'none';
    }
    document.getElementById("service-list").innerHTML = options;
  
    const servicePrice = document.querySelectorAll(".service-price");
  
    for (ser of servicePrice) {
      const inputPrice = ser.getElementsByTagName("input")[0];
      inputPrice.addEventListener("input", function (e) {
        if (e.target.value >= 0) {
          e.target.classList.remove("field-error");
        } else {
          e.target.classList.add("field-error");
        }
      });
    }
  
    // add services
    const styleProfileBtn = document.getElementById("style_profile_btn");
    styleProfileBtn.addEventListener("click", function (e) {
      serviceError.style.display = "none";
      const enableService = document.querySelectorAll(".enable-service");
      let checked = 0;
      let checkedRateField = 0;
      let dataArray = [];
      for (enable of enableService) {
        let checkInput = enable.getElementsByTagName("input")[0];
        let priceInput = enable.getElementsByTagName("input")[1];
        if (checkInput.checked == true) {
          if (priceInput.value != "" && priceInput.value >= 0) {
            checked++;
            const service_id = checkInput.value;
            const price = priceInput.value;
            dataArray.push({
              serviceId: service_id,
              hourlyRate: price,
            });
          } else {
            checkedRateField++;
            priceInput.classList.add("field-error");
          }
        }
      }
  
      if (checked == 0) {
        printError("#service-error", "Enable at least one service.");
        serviceError.style.display = "block";
      }
      if (checkedRateField > 0) {
        printError("#service-error", "Add rates in all enabled Services.");
        serviceError.style.display = "block";
      }
      if (checked > 0 && checkedRateField == 0) {
        printError("#service-error", "");
        stylistAddServices(styleProfileBtn, id, dataArray);
      }
    });
  
  //diable services
    const disableService = document.querySelectorAll('.disable_service');
    for( disableBtn of disableService){
      disableBtn.addEventListener('click', async function(e){
        const ele = e.currentTarget;
        ele.classList.add('spin');
        const id = ele.getAttribute('data-id');
        const selector = '#msg-' + id;
        const main = '#main-' + id;
  
        const statusMain = document.querySelector(main);
        let status;
        let statusValue = '';
        if( statusMain.getAttribute('data-policy')  === 'continue') {
          status = false;
          statusValue = 'deny';
        }else{
          status = true;
          statusValue = 'continue';
        }
        
        let bodyData = {
            serviceId: id,
            status: status,
          };
        let body = JSON.stringify(bodyData);
        
        const response = await sendRequest("stylist/update/service-status", {
          method: "PUT",
          authenticate: true,
          body,
    });
  
      if( response instanceof Error) {
        printError(selector, response);
        e.target.classList.remove('spin');
        return;
      }
  
        printError( selector, 'Service status updated successfully', 'success' );
        ele.classList.remove('spin');
        statusMain.classList.remove('continue');
        statusMain.classList.remove('deny');
        statusMain.classList.add(statusValue);
        statusMain.setAttribute('data-policy', statusValue);
        
      });
    }
  
  //update services
    const updateServices = document.querySelectorAll('.update_service');
    for( updateBtn of updateServices){
      updateBtn.addEventListener('click', async function(e){
        e.target.classList.add('spin');
        const id = e.target.getAttribute('data-id');
        const selector = '#msg-' + id;
        const inputSelector = '#input-' + id;
        const price = document.querySelector(inputSelector).value;
        
        let bodyData = {
            serviceId: id,
            price: price,
          };
        let body = JSON.stringify(bodyData);
        
        const response = await sendRequest("stylist/edit-service", {
          method: "PUT",
          authenticate: true,
          body,
    });
  
      if( response instanceof Error) {
        printError(selector, response);
        e.target.classList.remove('spin');
        return;
      }
  
        printError( selector, 'Service rate updated successfully', 'success' );
        e.target.classList.remove('spin');
        
      });
    }  
    
  };

  //Set Commission
  const setCommission = async () => {
    const commissionList = document.getElementById("commission-list");
    const response = await sendRequest("stylist/commission", {
      method: "GET",
      authenticate: true,
    });
  
    if( response instanceof Error) {
      alert('Error getting commissions');
      return;
    }
  
    if (response.length > 0 ){
    let rows = '';
      response?.forEach((row) => {
          rows += `<tr>
            <td>${row.createdAt.split('T')[0]}</td>
            <td>$${row.grossAmount}</td>
            <td>$${row.earnedProfit}</td>
            <td>${row.customerName}</td>
          </tr>`;
       });
    
    // commissionList.innerHTML = `<div class="comission_table_wrap">
    //     <table class="comission_table">
    //       <tbody><tr class="comission_box_header">
    //         <th>DATE</th>
    //         <th>PURCHASE</th>
    //         <th>COMMISSION</th>
    //         <th>CLIENT</th>
    //       </tr>
    //       ${rows}
    //       </tbody>
    //     </table>
    //    </div>`;
    //   }
  
  }
  
  }

  //get stylist user
   getUser();
  








